/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unneeded-ternary */
import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get, orderBy, isNumber } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { ToggleButton } from 'primereact/togglebutton';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import moment from 'moment';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors, converteData, replaceAll, formataDataMoment, formataMoeda, arredondar } from '../../../util/diversos';
import { Input100px, Input155px, Input200px, Input250px, Input400px } from '../../../styles/inputGroup';
import { fillColumns } from '../../../components/table';

import { obterListaTipoMovimentacao } from '../../../services/tipoMovimentacaoService';
import { obterListaCteSituacaoDocumento } from '../../../services/cteSituacaoDocumento';

import { obterListaCteModelo } from '../../../services/cteModelo';
import { obterListaCteTipo } from '../../../services/cteTipo';
import { obterListaCteTipoTomador } from '../../../services/cteTipoTomador';
import { obterListaCteTipoServico } from '../../../services/cteTipoServico';
import { obterListaCteTipoEmissao } from '../../../services/cteTipoEmissao';
import { obterListaCteModalidade } from '../../../services/cteModalidade';
import { obterListaCteModeloNfProdutor } from '../../../services/cteModeloNfProdutor';
import { obterListaCteModeloNfOutros } from '../../../services/cteModeloNfOutros';
import { obterListaCteCargaCUnid } from '../../../services/cteCargaCUnid';
import { obterListaCteCargaTpMed } from '../../../services/cteCargaTpMed';
import { obterListaCTeServicoCST } from '../../../services/cteServicoCST';
import { obterListaCTeServicoTipo } from '../../../services/cteServicoTipo';
import { obterListaCTeServicoFormaPagamento } from '../../../services/cteServicoFormaPagamento';

import Card from '../../../components/card';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Loading from '../../loading';

import ConsultaParticipante from '../participante/consultaParticipante';
import ConsultaNaturezaOperacao from '../naturezaOperacao/consultaNaturezaOperacao';
// eslint-disable-next-line import/no-cycle
import ConsultaCte from './consultaCTe';

export default function CadastroCtePropria({ payloadCadastro, childToParentConsulta }) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // console.log('payload: ', payloadCadastro);

  const clonar = get(payloadCadastro, 'clonar', false);

  const [id, setId] = useState(get(payloadCadastro, 'id', 0));

  const empresaCnpj = get(payloadCadastro, 'cnpjEmpresa', 0);
  const tipoMovimentacao = get(payloadCadastro, 'tipoMovimentacao', '');
  const propsTipoMovimentacao = get(payloadCadastro, 'propsTipoMovimentacao', '');

  let seriePadrao = get(payloadCadastro, 'seriePadrao', '1');
  if (!seriePadrao) {
    seriePadrao = '1';
  }

  const [ufEmpresa, setUfEmpresa] = useState(get(payloadCadastro, 'uf', ''));

  const [flag, setFlag] = useState('D'); // D = digitada , T = transmitida
  const [chaveAcesso, setChaveAcesso] = useState('');
  const [protocolo, setProtocolo] = useState('');
  const [numeroRecibo, setNumeroRecibo] = useState('');
  const [emissaoPropria, setEmissaoPropria] = useState('SAIDA');
  const [cnpjEmpresa, setCnpjEmpresa] = useState('');

  const [filteredCfop, setFilteredCfop] = useState(null);

  const [tabActiveIndex, setTabActiveIndex] = useState(0);

  const [disableToCteOS, setDisableToCteOs] = useState(false);

  // cteOS
  const [infServicoXDescServ, setInfServicoXDescServ] = useState('');
  const [infServicoQuantidadeCarga, setInfServicoQuantidadeCarga] = useState('');

  const [mod, setMod] = useState('57');
  const [serie, setSerie] = useState(seriePadrao);
  const [numeroCt, setNumeroCt] = useState('0');
  const [dhEmi, setDhEmi] = useState(new Date());
  const [tpCTe, setTpCTe] = useState('NORMAL');
  const [cfop, setCfop] = useState('');
  const [tipoTomador, setTipoTomador] = useState('REMETENTE');
  const [tipoServico, setTipoServico] = useState('NORMAL');
  const [natOp, setNatOp] = useState('');
  const [codSit, setCodSit] = useState('REGULAR');
  const [retira, setRetira] = useState(true); // se o recebedor retira no destino
  const [globalizado, setGlobalizado] = useState(false); // varios documentos mas apenas um tomador (remetente ou destinatario)
  const [tpEmis, setTpEmis] = useState('NORMAL'); // normal, NFF, EPED, FSDA, SVCRS, SVCSP
  const [modalidade, setModalidade] = useState('RODOVIARIO');

  const [idTomador, setIdTomador] = useState(null);
  const [nomeTomador, setNomeTomador] = useState('');
  const [ieTomador, setIeTomador] = useState('');

  const [idRemetente, setIdRemetente] = useState(null);
  const [nomeRemetente, setNomeRemetente] = useState('');
  const [ieRemetente, setIeRemetente] = useState('');

  const [idDestinatario, setIdDestinatario] = useState(null);
  const [nomeDestinatario, setNomeDestinatario] = useState('');
  const [ieDestinatario, setIeDestinatario] = useState('');

  const [showCadastroNfRef, setShowCadastroNfRef] = useState(false);
  const [showCadastroQuantidadeCarga, setShowCadastroQuantidadeCarga] = useState(false);
  const [showCadastroServicoValor, setShowCadastroServicoValor] = useState(false);
  const [showCadastroDuplicata, setShowCadastroDuplicata] = useState(false);
  const [showCadastroRodoviario, setShowCadastroRodoviario] = useState(false);
  const [showCadastroCteComplementar, setShowCadastroCteComplementar] = useState(false);
  const [showConsultaTomador, setShowConsultaTomador] = useState(false);
  const [showConsultaRemetente, setShowConsultaRemetente] = useState(false);
  const [showConsultaDestinatario, setShowConsultaDestinatario] = useState(false);
  const [showConsultaNaturezaOperacao, setShowConsultaNaturezaOperacao] = useState(false);
  const [showConsultaRecebedor, setShowConsultaRecebedor] = useState(false);
  const [showConsultaExpedidor, setShowConsultaExpedidor] = useState(false);
  const [showConsultaCte, setShowConsultaCte] = useState(false);
  const [showConfirmCancelarDigitacaoCTe, setShowConfirmCancelarDigitacaoCTe] = useState(false);
  const [showConfirmDeleteNfRef, setShowConfirmDeleteNfRef] = useState(false);
  const [showConfirmDeleteQuantidadeCarga, setShowConfirmDeleteQuantidadeCarga] = useState(false);
  const [showConfirmDeleteServicoValor, setShowConfirmDeleteServicoValor] = useState(false);
  const [showConfirmDeleteDuplicata, setShowConfirmDeleteDuplicata] = useState(false);
  const [showConfirmDeleteRodoviario, setShowConfirmDeleteRodoviario] = useState(false);
  const [showConfirmDeleteCteComplementar, setShowConfirmDeleteCteComplementar] = useState(false);

  const [listaNfRef, setListaNfRef] = useState([]);
  const [listaQuantidadeCarga, setListaQuantidadeCarga] = useState([]);
  const [listaNatOps, setListaNatOps] = useState([]);
  const [listaCfops, setListaCfops] = useState([]);
  const [setListaEmpresas] = useState([]);
  const [listaMunicipio, setListaMunicipio] = useState([]);

  // IBS / CBS
  const [cClassTrib, setCClassTrib] = useState('');
  const [filteredCClassTrib, setFilteredCClassTrib] = useState(null);
  const [listaCClassTrib, setListaCClassTrib] = useState([]);
  const [ibscbsCst, setIbscbsCst] = useState('');
  const [filteredIbscbsCst, setFilteredIbscbsCst] = useState(null);
  const [listaIbscbsCst, setListaIbscbsCst] = useState([]);
  const [indDoacao, setIndDoacao] = useState(false);

  const [editandoNfRef, setEditandoNfRef] = useState(0);
  const [editandoQuantidadeCarga, setEditandoQuantidadeCarga] = useState(0);
  const [editandoServicoValor, setEditandoServicoValor] = useState(0);
  const [editandoDuplicata, setEditandoDuplicata] = useState(0);
  const [editandoRodoviario, setEditandoRodoviario] = useState(0);
  const [editandoCteComplementar, setEditandoCteComplementar] = useState(0);

  const [selectedNfRef, setSelectedNfRef] = useState(null);
  const [selectedQuantidadeCarga, setSelectedQuantidadeCarga] = useState(null);
  const [selectedServicoValor, setSelectedServicoValor] = useState(null);
  const [selectedDuplicata, setSelectedDuplicata] = useState(null);
  const [selectedRodoviario, setSelectedRodoviario] = useState(null);
  const [selectedCteComplementar, setSelectedCteComplementar] = useState(null);

  const [filteredNatOp, setFilteredNatOp] = useState(null);

  const listaModelo = obterListaCteModelo();
  const listaTipo = obterListaCteTipo();
  const listaSituacaoDocumento = obterListaCteSituacaoDocumento();
  const listaTipoMovimentacao = obterListaTipoMovimentacao();
  const listaTipoTomador = obterListaCteTipoTomador();
  const listaTipoServico = obterListaCteTipoServico();
  const listaTipoEmissao = obterListaCteTipoEmissao();
  const listaModalidade = obterListaCteModalidade();
  const listaModeloNfProdutor = obterListaCteModeloNfProdutor();
  const listaModeloNfOutros = obterListaCteModeloNfOutros();
  const listaCargaCUnid = obterListaCteCargaCUnid();
  const listaCargaTpMed = obterListaCteCargaTpMed();
  const listaServicoCST = obterListaCTeServicoCST();
  const listaServicoTipo = obterListaCTeServicoTipo();
  const listaServicoFormaPagamento = obterListaCTeServicoFormaPagamento();

  const [nfRefDataEmissao, setNfRefDataEmissao] = useState(null);
  const [nfRefSerie, setNfRefSerie] = useState('');
  const [nfRefNumeroNF, setNfRefNumeroNF] = useState('');
  const [nfRefPeso, setNfRefPeso] = useState(0);
  const [nfRefValorTotal, setNfRefValorTotal] = useState(0);
  const [nfRefChaveAcesso, setNfRefChaveAcesso] = useState('');
  const [nfRefSuframa, setNfRefSuframa] = useState(0);
  const [nfRefDataEntrega, setNfRefDataEntrega] = useState(null);

  const [nfRefNumeroRomaneio, setNfRefNumeroRomaneio] = useState(null);
  const [nfRefNumeroPedido, setNfRefNumeroPedido] = useState(null);
  const [nfRefMod, setNfRefMod] = useState('');
  const [nfRefModeloNfProdutor, setNfRefModeloNfProdutor] = useState('');
  const [nfRefCfopPredominante, setNfRefCfopPredominante] = useState('');
  const [nfRefValorBcIcms, setNfRefValorBcIcms] = useState(0);
  const [nfRefValorIcms, setNfRefValorIcms] = useState(0);
  const [nfRefValorBcIcmsSt, setNfRefValorBcIcmsSt] = useState(0);
  const [nfRefValorIcmsSt, setNfRefValorIcmsSt] = useState(0);
  const [nfRefValorTotalProdutos, setNfRefValorTotalProdutos] = useState(0);

  const [nfRefModeloNfOutros, setNfRefModeloNfOutros] = useState('');
  const [nfRefDescricao, setNfRefDescricao] = useState('');

  const [infCargaProPred, setInfCargaProPred] = useState('');
  const [infCargaOutrasCaracCarga, setInfCargaOutrasCaracCarga] = useState('');
  const [infCargaValorTotalCarga, setInfCargaValorTotalCarga] = useState(0);
  const [infCargaOutrasCaracServico, setInfCargaOutrasCaracServico] = useState('');
  const [infCargaValorTotalServico, setInfCargaValorTotalServico] = useState(0);

  // quantidades de carga
  const [cargaUnidade, setCargaUnidade] = useState(null);
  const [cargaTipoMedida, setCargaTipoMedida] = useState(null);
  const [cargaQuantidadecarga, setCargaQuantidadeCarga] = useState(0);

  const [servicoCST, setServicoCST] = useState('TRIBUTADO');
  const [servicoBCICMS, setServicoBCICMS] = useState(0);
  const [servicoRedBCICMS, setServicoRedBCICMS] = useState(0);
  const [servicoAliquotaICMS, setServicoAliquotaICMS] = useState(0);
  const [servicoValorICMS, setServicoValorICMS] = useState(0);
  const [servicoValorCredito, setServicoValorCredito] = useState(0);
  const [servicoValorIsento, setServicoValorIsento] = useState(0);
  const [servicoValorOutro, setServicoValorOutro] = useState(0);

  const [listaServicosValores, setListaServicosValores] = useState([]);
  const [servicoDescricao, setServicoDescricao] = useState('');
  const [servicoValor, setServicoValor] = useState(0);

  const [partilhaVIcmsUfIni, setPartilhaVIcmsUfIni] = useState(0);
  const [partilhaVBcUfFim, setPartilhaVBcUfFim] = useState(0);
  const [partilhaPIcmsUfFim, setPartilhaPIcmsUfFim] = useState(0);
  const [partilhaVIcmsUfFim, setPartilhaVIcmsUfFim] = useState(0);
  const [partilhaPFcpUfFim, setPartilhaPFcpUfFim] = useState(0);
  const [partilhaVFcpUfFim, setPartilhaVFcpUfFim] = useState(0);
  const [partilhaPIcmsInter, setPartilhaPIcmsInter] = useState(0);

  const [fatFormaPag, setFatFormaPag] = useState('');
  const [fatNFat, setFatNFat] = useState('');
  const [fatVOrig, setFatVOrig] = useState(0);
  const [fatVDesc, setFatVDesc] = useState(0);
  const [fatVLiq, setFatVLiq] = useState(0);

  const [listaDuplicata, setListaDuplicata] = useState([]);
  const [duplicataData, setDuplicataData] = useState(null);
  const [duplicataNumero, setDuplicataNumero] = useState('');
  const [duplicataValor, setDuplicataValor] = useState('');

  // rodoviario
  const [listaRodoviario, setListaRodoviario] = useState([]);
  const [rntrc, setRntrc] = useState('');
  const [rodSerie, setRodSerie] = useState('');
  const [rodNumero, setRodNumero] = useState('');
  const [rodDataEmissao, setRodDataEmissao] = useState(null);
  const [rodCnpj, setRodCnpj] = useState('');
  const [rodIE, setRodIE] = useState('');
  const [rodUF, setRodUF] = useState('');
  const [rodTelefone, setRodTelefone] = useState('');
  const [rodCodigoInterno, setRodCodigoInterno] = useState('');

  // rodoviario - OS
  const [taf, setTaf] = useState('');
  const [nroRegistroEstadual, setNroRegistroEstadual] = useState('');

  const [listaCteComplementar, setListaCteComplementar] = useState([]);
  const [complementarChCte, setComplementarChCte] = useState('');

  const [idRecebedor, setIdRecebedor] = useState(null);
  const [nomeRecebedor, setNomeRecebedor] = useState('');
  const [ieRecebedor, setIeRecebedor] = useState('');
  const [ufRecebedor, setUfRecebedor] = useState('');

  const [idExpedidor, setIdExpedidor] = useState(null);
  const [nomeExpedidor, setNomeExpedidor] = useState('');
  const [ieExpedidor, setIeExpedidor] = useState('');
  const [ufExpedidor, setUfExpedidor] = useState('');

  const [filteredMunicipioInicio, setFilteredMunicipioInicio] = useState(null);
  const [codigoMunicipioInicio, setCodigoMunicipioInicio] = useState(null);
  const [cidadeInicio, setCidadeInicio] = useState('');
  const [ufInicio, setUfInicio] = useState('');

  const [filteredMunicipioFim, setFilteredMunicipioFim] = useState(null);
  const [codigoMunicipioFim, setCodigoMunicipioFim] = useState('');
  const [cidadeFim, setCidadeFim] = useState('');
  const [ufFim, setUfFim] = useState('');
  const [infoAdicionais, setInfoAdicionais] = useState('');

  // chave cte a substituir quando nota substituicao
  const [substituicaoCteChaveAcesso, setSubstituicaoCteChaveAcesso] = useState('');

  const [columnsSetupNFRef] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'dEmi', header: 'Data', sort: true },
    { field: 'nDoc', header: 'Número Doc', sort: true },
    { field: 'serie', header: 'Serie', sort: true },
    { field: 'peso', header: 'Peso', sort: true },
    { field: 'vnf', header: 'Valor', sort: true },
  ]);

  const [columnsSetupQuantidadeCarga] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'cUnid', header: 'Unidade', sort: true },
    { field: 'tpMed', header: 'Tipo Medida', sort: true },
    { field: 'qCarga', header: 'Quantidade', sort: true },
  ]);

  const [columnsSetupServicoValor] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'descricao', header: 'Descrição', sort: true },
    { field: 'valor', header: 'Valor', sort: true },
  ]);

  const [columnsSetupDuplicata] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'duplicataData', header: 'Data', sort: true },
    { field: 'numero', header: 'Número', sort: true },
    { field: 'valor', header: 'Valor', sort: true },
  ]);

  const [columnsSetupRodoviario] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'serie', header: 'Série', sort: true },
    { field: 'rodoviarioDataEmissao', header: 'Data Emissão', sort: true },
    { field: 'cnpj', header: 'CNPJ', sort: true },
    { field: 'ie', header: 'IE', sort: true },
    { field: 'uf', header: 'UF', sort: true },
    { field: 'codigoInterno', header: 'Código Interno', sort: true },
    { field: 'telefone', header: 'Telefone', sort: true },
  ]);

  const [columnsSetupCteComplementar] = useState([
    { field: 'item', header: 'Item', sort: true },
    { field: 'chaveAcesso', header: 'Chave Acesso', sort: true },
  ]);

  useEffect(() => {
    if (mod === '67') {
      setDisableToCteOs(true);
    } else {
      setDisableToCteOs(false);
    }
  }, [mod]);

  const searchCfop = (event) => {
    setCfop(event.query);

    const listDropdown = [];
    listaCfops.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredCfop(listDropdown);
  };

  const searchCClassTrib = (event) => {
    setCClassTrib(event.query);

    const listDropdown = [];
    listaCClassTrib.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredCClassTrib(listDropdown);
  };

  const searchIbscbsCst = (event) => {
    setIbscbsCst(event.query);

    const listDropdown = [];
    listaIbscbsCst.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredIbscbsCst(listDropdown);
  };

  async function setUltimoNumero(serie) {
    if (id === 0) {
      try {
        setIsLoading(true);

        (serie === '') ? serie = '1' : '';

        await axiosAdmin.get(`/cte/ultimonumero?cnpjEmpresa=${empresaCnpj}&emissaoPropria=true&serie=${serie}`).then(res => {
          const ultimoNumero = res.data;
          if (res.data !== null) {
            const proximoNumero = parseInt(ultimoNumero, 10) + 1;
            setNumeroCt(proximoNumero.toString());
          }
        }).catch(() => {
          setNumeroCt(numeroCt);
        });
      } catch (err) {
        toast.warn('Não foi possível achar o número da nota');
      } finally {
        setIsLoading(false);
      }
    }
  }

  async function setUltimoNumeroClonagem(serie) {
    try {
      setIsLoading(true);

      (serie === '') ? serie = '1' : '';

      await axiosAdmin.get(`/cte/ultimonumero?cnpjEmpresa=${empresaCnpj}&emissaoPropria=true&serie=${serie}`).then(res => {
        const ultimoNumero = res.data;
        // console.log('ultimo numero: ', ultimoNumero);
        if (res.data !== null) {
          const proximoNumero = parseInt(ultimoNumero, 10) + 1;
          setNumeroCt(proximoNumero.toString());
        }
      }).catch(() => {
        setNumeroCt(numeroCt);
      });
    } catch (err) {
      toast.warn('Não foi possível achar o número da nota');
    } finally {
      setIsLoading(false);
    }
  }

  const searchMunicipioInicio = (event) => {
    const listDropdown = [];

    listaMunicipio.forEach(element => {
      if (element.value.toLowerCase().startsWith(event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setFilteredMunicipioInicio(listDropdown);
  };

  const searchMunicipioFim = (event) => {
    const listDropdown = [];

    listaMunicipio.forEach(element => {
      if (element.value.toLowerCase().startsWith(event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setFilteredMunicipioFim(listDropdown);
  };

  useEffect(() => {
    if (propsTipoMovimentacao !== 'entrada') {
      setUltimoNumero(serie.toString());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serie]);

  useEffect(() => {
    let newTitle = 'NF-e Emissão Própria - Cadastro';
    if (id) {
      newTitle = 'NF-e Emissão Própria - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    const chaveAcesso = get(payloadCadastro, 'chaveAcesso', '');

    if (!id && tipoMovimentacao !== 'entrada') return; // tipoMovimentacao vem do handleregister do consultanfe

    const getDataById = async () => {
      const { data } = await axiosAdmin.get(`/cte/${id}`);

      return data;
    };

    const setarListaQuantidadeCarga = (data) => {
      let item = 0;
      const _dataQuantidadeCarga = [];
      data.listaCteQuantidadeCarga.forEach(element => {
        item = item + 1;

        _dataQuantidadeCarga.push({
          item,
          cUnid: element.cunid,
          tpMed: element.tpMed,
          qCarga: element.qcarga,
        });
      });

      setListaQuantidadeCarga(_dataQuantidadeCarga);
    };

    const setarListaServico = (data) => {
      let item = 0;
      const _dataServicos = [];
      data.listaCteServico.forEach(element => {
        item = item + 1;

        _dataServicos.push({
          item,
          descricao: element.descricao,
          valor: element.valor,
        });
      });

      setListaServicosValores(_dataServicos);
    };

    const setarListaDuplicata = (data) => {
      let item = 0;
      const _dataDuplicata = [];
      data.listaCteDuplicata.forEach(element => {
        item = item + 1;

        const _data = formataDataMoment(converteData(element.data), '/');
        _dataDuplicata.push({
          item,
          duplicataData: _data,
          numero: element.numero,
          valor: element.valor,
        });
      });

      setListaDuplicata(_dataDuplicata);
    };

    const setarListaRodoviario = (data) => {
      let item = 0;
      const _dataRodoviario = [];
      data.listaCteRodoviario.forEach(element => {
        item = item + 1;

        const _dataEmissao = formataDataMoment(converteData(element.dataEmissao), '/');

        _dataRodoviario.push({
          item,
          rodoviarioDataEmissao: _dataEmissao,
          numero: element.numero,
          serie: element.serie,
          cnpj: element.cnpj,
          ie: element.ie,
          uf: element.uf,
          codigoInterno: element.cint,
          telefone: element.telefone,
        });
      });

      setListaRodoviario(_dataRodoviario);
    };

    const setarListaCteComplementar = (data) => {
      let item = 0;
      const _dataCteComplementar = [];
      data.listaCteComplementar.forEach(element => {
        item = item + 1;

        _dataCteComplementar.push({
          item,
          chaveAcesso: element.chaveAcesso,
        });
      });

      setListaCteComplementar(_dataCteComplementar);
    };

    const setarListaNFRef = (data) => {
      let itemNfReferenciada = 0;
      const _dataNFRef = [];
      data.listaCteNFReferenciada.forEach(elementNfReferenciada => {
        itemNfReferenciada = itemNfReferenciada + 1;

        const _dEmi = formataDataMoment(converteData(elementNfReferenciada.demi), '/');
        const _dPrev = formataDataMoment(converteData(elementNfReferenciada.dprev), '/');

        _dataNFRef.push({
          item: itemNfReferenciada,
          dEmi: _dEmi,
          nDoc: elementNfReferenciada.ndoc,
          serie: elementNfReferenciada.serie,
          peso: elementNfReferenciada.peso,
          vnf: elementNfReferenciada.vnf,
          chave: elementNfReferenciada.chave,
          pin: elementNfReferenciada.pin,
          // dPrev: _dPrev,
          nRoma: elementNfReferenciada.nroma,
          nPed: elementNfReferenciada.nped,
          nCFOP: elementNfReferenciada.ncfop,
          vBC: elementNfReferenciada.vbc,
          vICMS: elementNfReferenciada.vicms,
          vBCST: elementNfReferenciada.vbcst,
          vST: elementNfReferenciada.vst,
          vProd: elementNfReferenciada.vprod,
          vNF: elementNfReferenciada.vnf,
          mod: elementNfReferenciada.mod != null ? elementNfReferenciada.mod : '',
          outrosTipo: elementNfReferenciada.outrosTipo != null ? elementNfReferenciada.outrosTipo : '',
          outrosDescricao: elementNfReferenciada.outrosDescricao,
          produtor: elementNfReferenciada.produtor != null ? elementNfReferenciada.produtor : '',
        });
      });

      setListaNfRef(_dataNFRef);
    };

    const searchMunicipioInicio = (event) => {
      const listDropdown = [];

      listaMunicipio.forEach(element => {
        if (element.value.toLowerCase().startsWith(event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
          listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
        }
      });

      setFilteredMunicipioInicio(listDropdown);
    };

    const searchMunicipioFim = (event) => {
      const listDropdown = [];

      listaMunicipio.forEach(element => {
        if (element.value.toLowerCase().startsWith(event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
          listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
        }
      });

      setFilteredMunicipioFim(listDropdown);
    };

    async function getData() {
      try {
        let data = null;
        if (id > 0) {
          data = await getDataById();
        }

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          navigate('/consultacte');
          toast.error('Acesso negado');
        }

        const _dhEmi = converteData(data.dhEmi, true);

        setFlag(data.flag);
        setEmissaoPropria(data.emissaoPropria ? 'SAIDA' : 'ENTRADA');
        setChaveAcesso(data.chaveAcesso);
        setProtocolo(data.protocolo);
        setNumeroRecibo(data.numeroRecibo);
        setNumeroCt(data.numeroCt);
        setDhEmi(_dhEmi);
        setTpCTe(data.tpCTe);
        setNatOp(data.natOp);
        setTpEmis(data.tpEmis);
        setMod(data.mod);
        setSerie(data.serie);
        setCodSit(data.codSit);
        setCfop(data.cfop);
        setTipoTomador(data.tipoTomador);
        setTipoServico(data.tpServ);
        setGlobalizado(data.globalizado);
        setRetira(data.retira);
        setModalidade(data.modal);
        setInfServicoXDescServ(data.infServicoXDescServ);
        setInfServicoQuantidadeCarga(data.infServicoQuantidadeCarga);

        setIdTomador(data.tomador.id);
        setNomeTomador(data.tomador.razaoSocial);
        setIeTomador(data.tomador.inscricaoEstadual ? data.tomador.inscricaoEstadual : '');

        if (data.remetente) {
          setIdRemetente(data.remetente.id);
          setNomeRemetente(data.remetente.razaoSocial);
          setIeRemetente(data.remetente.inscricaoEstadual ? data.remetente.inscricaoEstadual : '');
        }

        if (data.destinatario) {
          setIdDestinatario(data.destinatario.id);
          setNomeDestinatario(data.destinatario.razaoSocial);
          setIeDestinatario(data.destinatario.inscricaoEstadual ? data.destinatario.inscricaoEstadual : '');
        }

        setarListaNFRef(data);
        setarListaQuantidadeCarga(data);
        setarListaServico(data);
        setarListaDuplicata(data);
        setarListaRodoviario(data);
        setarListaCteComplementar(data);

        setInfCargaProPred(data.prodPredominante);
        setInfCargaOutrasCaracCarga(data.xcaracAd);
        setInfCargaValorTotalCarga(data.vcarga);
        setInfCargaOutrasCaracServico(data.xcaracServ);
        setInfCargaValorTotalServico(data.vserv);

        setServicoCST(data.codSt);
        setServicoBCICMS(data.totalVBC);
        setServicoAliquotaICMS(data.aliquotaIcms);
        setServicoRedBCICMS(data.percentualBcRed);
        setServicoValorCredito(data.valorCreditoSt);
        setServicoValorIsento(data.totalVIsento);
        setServicoValorOutro(data.totalVOutro);
        setServicoValorICMS(data.totalVICMS);

        setPartilhaVBcUfFim(data.vbcuffim);
        setPartilhaPIcmsUfFim(data.picmsuffim);
        setPartilhaVIcmsUfFim(data.vicmsuffim);
        setPartilhaPFcpUfFim(data.pfcpuffim);
        setPartilhaVFcpUfFim(data.vfcpuffim);
        setPartilhaPIcmsInter(data.picmsinter);
        setPartilhaVIcmsUfIni(data.vicmsufini);

        setFatFormaPag(data.fatFormaPag);
        setFatNFat(data.nfat);
        setFatVOrig(data.fatVOrig);
        setFatVDesc(data.fatVDesc);
        setFatVLiq(data.fatVLiq);

        setRntrc(data.rntrc);
        setTaf(data.taf);
        setNroRegistroEstadual(data.nroRegistroEstadual);

        if (data.recebedor) {
          setIdRecebedor(data.recebedor.id);
          setNomeRecebedor(data.recebedor.razaoSocial);
          setIeRecebedor(data.recebedor.inscricaoEstadual ? data.recebedor.inscricaoEstadual : '');
          setUfRecebedor(data.recebedor.uf);
        }

        if (data.expedidor) {
          setIdExpedidor(data.expedidor.id);
          setNomeExpedidor(data.expedidor.razaoSocial);
          setIeExpedidor(data.expedidor.inscricaoEstadual ? data.expedidor.inscricaoEstadual : '');
          setUfExpedidor(data.expedidor.uf);
        }

        setCodigoMunicipioInicio(data.cmunIni);
        setCidadeInicio(data.xmunIni);
        setUfInicio(data.ufini);
        setCodigoMunicipioFim(data.cmunFim);
        setCidadeFim(data.xmunFim);
        setUfFim(data.uffim);
        setInfoAdicionais(data.infoAdicionais);
        setSubstituicaoCteChaveAcesso(data.chaveAcessoSubstituicao);

        if (clonar) {
          setId(0);
          setDhEmi(new Date());
          setFlag('D');
          setCodSit('REGULAR');
          setEmissaoPropria('SAIDA');
          setProtocolo('');
          setChaveAcesso('');
          setUltimoNumeroClonagem(data.serie);
        }
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }
    }

    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, navigate]);

  async function verificarSeMultiEmpresa(idUsuario) {
    try {
      setIsLoading(true);

      const params = `/usuario/${idUsuario}`;

      const response = await axiosAdmin.get(params);

      const _listaEmpresas = get(response.data, 'listaEmpresas', []);

      const listDropdown = [];

      let cnpjPreenchido = false;
      let _cnpjEmpresaStore = get(store.getState().auth, 'cnpjEmpresa', '');

      if (_cnpjEmpresaStore !== null && _cnpjEmpresaStore !== '') {
        setCnpjEmpresa(_cnpjEmpresaStore);
        cnpjPreenchido = true;
      }

      _listaEmpresas.forEach(element => {
        if (!cnpjPreenchido) {
          setCnpjEmpresa(element.cnpj);
          _cnpjEmpresaStore = element.cnpj;
          cnpjPreenchido = true;
        }

        if (element.cnpj === _cnpjEmpresaStore) {
          setUfEmpresa(element.uf); // para calculo tributos
          setRntrc(element.rntrc);
        }

        const nomeEmpresa = element.nomeFantasia ? element.nomeFantasia : element.razaoSocial;

        listDropdown.push({ label: nomeEmpresa, value: element.cnpj });
      });

      listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

      setListaEmpresas(listDropdown);
    } catch (err) {
      // if (mostrarMensagemErro) {
      //   displayErrors(err, dispatch, navigate, '/', '');
      // }
      // mostrarMensagemErro = false;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  async function getNatOps() {
    const idUsuario = get(store.getState().auth.user, 'id', 0);

    const listDropdown = [];
    try {
      setIsLoading(true);

      const { data: _natOps } = await axiosAdmin.get(`/naturezaoperacao/?idUsuario=${idUsuario}`);

      _natOps.forEach(element => {
        listDropdown.push({ label: element.descricao, value: element.id });
      });

      setListaNatOps(listDropdown);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getNatOps();

    async function getCfops() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _cfops } = await axiosAdmin.get('/cfop/');

        _cfops.forEach(element => {
          if (element.descricao.includes('transporte')) {
            const descricao = element.codigo + ' - ' + element.descricao.trim();
            listDropdown.push({ label: descricao, value: element.id });
          }
        });

        setListaCfops(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    getCfops();

    async function getCClassTrib() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _cClassTribs } = await axiosAdmin.get('/classtribibscbs/');

        _cClassTribs.forEach(element => {
          if (element.descricao.includes('transporte')) {
            const descricao = element.codigo + ' - ' + element.descricao.trim();
            listDropdown.push({ label: descricao, value: element.id });
          }
        });

        setListaCClassTrib(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    // getCClassTrib();

    async function getIbscbsCst() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _ibscbsCst } = await axiosAdmin.get('/cstibscbs/');

        _ibscbsCst.forEach(element => {
          const descricao = element.codigo + ' - ' + element.descricao.trim();
          listDropdown.push({ label: descricao, value: element.id });
        });

        setListaIbscbsCst(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    // getIbscbsCst();

    async function getUnidadeFederacao() {
      const listDropdown = [];
      try {
        setIsLoading(true);

        const { data: _ufs } = await axiosAdmin.get('/unidadefederacao/');

        _ufs.forEach(element => {
          listDropdown.push({ label: element.sigla, value: element.sigla });
        });
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
    getUnidadeFederacao();

    async function getMunicipios() {
      try {
        setIsLoading(true);

        const listDropdown = [];

        const { data: _municipios } = await axiosAdmin.get('/municipio');

        _municipios.forEach(element => {
          listDropdown.push({ label: element.descricao, value: element.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), codigo: element.codigo, uf: element.uf });
        });

        setListaMunicipio(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getMunicipios();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);
      const cnpjEmpresa = get(payloadCadastro, 'cnpjEmpresa', '');

      listaNfRef.forEach(element => {
        element.dEmi = replaceAll(element.dEmi, '/', '-');
        // element.dPrev = replaceAll(element.dPrev, '/', '-');
      });

      listaDuplicata.forEach(element => {
        if (element.duplicataData !== null && element.duplicataData !== undefined) {
          element.data = replaceAll(element.duplicataData, '/', '-');
        }
      });

      listaRodoviario.forEach(element => {
        if (element.rodoviarioDataEmissao !== null && element.rodoviarioDataEmissao !== undefined) {
          element.dataEmissao = replaceAll(element.rodoviarioDataEmissao, '/', '-');
        }
        element.cInt = element.codigoInterno;
      });

      let _dhEmi = null;
      if (dhEmi) {
        _dhEmi = formataDataMoment(dhEmi, '-', true);
      }

      const shippingData = {
        flag,
        chaveAcesso,
        protocolo,
        numeroRecibo,
        emissaoPropria: emissaoPropria === 'SAIDA' ? true : false,
        idUsuario,
        cnpjEmpresa,
        tomador: idTomador,
        remetente: idRemetente,
        destinatario: idDestinatario,
        cCt: Math.random().toString().slice(2, 10),
        numeroCt,
        dhEmi: _dhEmi,
        tpCTe,
        natOp: natOp.label ? natOp.label : natOp,
        tpEmis,
        codSit,
        serie,
        cfop: cfop.label ? cfop.label.substring(0, 4) : cfop,
        tipoTomador,
        tpServ: tipoServico,
        retira,
        globalizado,
        mod,
        modal: modalidade,
        prodPredominante: infCargaProPred,
        xCaracAd: infCargaOutrasCaracCarga,
        vCarga: infCargaValorTotalCarga,
        xCaracServ: infCargaOutrasCaracServico,
        vServ: infCargaValorTotalServico,
        // servicos (valores)
        codSt: servicoCST,
        totalVBC: servicoBCICMS,
        percentualBcRed: servicoRedBCICMS,
        aliquotaIcms: servicoAliquotaICMS,
        totalVICMS: servicoValorICMS,
        valorCreditoSt: servicoValorCredito,
        totalVIsento: servicoValorIsento,
        totalVOutro: servicoValorOutro,
        // partilha
        vICMSUFIni: partilhaVIcmsUfIni,
        vBCUFFim: partilhaVBcUfFim,
        pICMSUFFim: partilhaPIcmsUfFim,
        vICMSUFFim: partilhaVIcmsUfFim,
        pICMSInter: partilhaPIcmsInter,
        pFCPUFFim: partilhaPFcpUfFim,
        vFCPUFFim: partilhaVFcpUfFim,
        // fatura
        fatFormaPag,
        nFat: fatNFat,
        fatVOrig,
        fatVDesc,
        fatVLiq,
        //
        recebedor: idRecebedor,
        expedidor: idExpedidor,
        cMunIni: codigoMunicipioInicio,
        xMunIni: cidadeInicio,
        uFIni: ufInicio,
        cMunFim: codigoMunicipioFim,
        xMunFim: cidadeFim,
        uFFim: ufFim,
        infoAdicionais,
        chaveAcessoSubstituicao: substituicaoCteChaveAcesso,
        rntrc,
        taf,
        nroRegistroEstadual,
        infServicoXDescServ,
        infServicoQuantidadeCarga,
        //
        listaCTeNFReferenciadaDTO: listaNfRef,
        listaCTeQuantidadeCargaDTO: listaQuantidadeCarga,
        listaCTeServicoDTO: listaServicosValores,
        listaCTeDuplicataDTO: listaDuplicata,
        listaCTeRodoviarioDTO: listaRodoviario,
        listaCTeComplementarDTO: listaCteComplementar,
      };

      // console.log('shippingdata: ', shippingData);

      let payloadDataTableList = {};

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/cte/${id}`, shippingData), 'data', {});
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/cte', shippingData), 'data', {});
      }

      toast.success('CT-e salvo com sucesso');
      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      // console.log('err:', err);
      displayErrors(err, dispatch, navigate, '', 'Erro ao salvar o registro.');
    } finally {
      setIsLoading(false);
    }
  }

  // eslint-disable-next-line consistent-return
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (serie <= 0 || serie === null) {
      toast.info('Série deve ser maior que zero.');
      return false;
    }

    if (serie === 'U') {
      setSerie('0');
    }

    if (numeroCt <= 0) {
      toast.info('Número da CT-e incorreto.');
      return false;
    }

    if (dhEmi === null) {
      toast.info('Data inválida.');
      return false;
    }

    if (cfop === null || cfop === '' || cfop.length < 4) {
      toast.info('CFOP inválido.');
      return false;
    }

    if (natOp === null || natOp === '') {
      toast.info('Natureza da operação inválida.');
      return false;
    }

    if (idTomador === null) {
      toast.info('Tomador da CT-e não selecionado.');
      return false;
    }

    if (mod === '57') {
      if (idRemetente === null && tipoServico !== 'INTERMEDIARIO' && tipoServico !== 'MULTIMODAL') {
        toast.info('Remetente da CT-e não selecionado.');
        return false;
      }

      if (idDestinatario === null && tipoServico !== 'INTERMEDIARIO' && tipoServico !== 'MULTIMODAL') {
        toast.info('Destinatário da CT-e não selecionado.');
        return false;
      }

      if (listaNfRef.length <= 0 && (tipoServico !== 'INTERMEDIARIO' && tipoServico !== 'MULTIMODAL')) {
        toast.info('Pelo menos um documento referenciado deve ser informado.');
        return false;
      }

      if (listaQuantidadeCarga.length <= 0) {
        toast.info('Quantidades por Carga deve conter pelo menos 1 registro.');
        return false;
      }

      if (rntrc === '' || rntrc === null) {
        toast.info('RNTRC deve ser informado para rodoviário.');
        return false;
      }

      if (rntrc.length < 8) {
        toast.info('RNTRC deve conter 8 dígitos.');
        return false;
      }
      if (infCargaProPred === '') {
        toast.info('Produto Predominante deve ser informado.');
        return false;
      }
      if (tipoTomador === 'REMETENTE' && idRemetente === null) {
        toast.info('Remetente deve ser informado quanto tipo tomador for Remetente.');
        return false;
      }
      if (tipoTomador === 'DESTINATARIO' && idDestinatario === null) {
        toast.info('Destinatário deve ser informado quanto tipo tomador for Destinatário.');
        return false;
      }
      if (tipoTomador === 'RECEBEDOR' && idRecebedor === null) {
        toast.info('Recebedor deve ser informado quanto tipo tomador for Recebedor.');
        return false;
      }
      if (tipoTomador === 'EXPEDIDOR' && idExpedidor === null) {
        toast.info('Expedidor deve ser informado quanto tipo tomador for Expedidor.');
        return false;
      }
    }

    if (mod === '67') {
      if (taf === '') {
        toast.info('TAF deve ser informado para rodoviário OS.');
        return false;
      }
      if (taf.length < 12) {
        toast.info('TAF deve conter 12 dígitos.');
        return false;
      }
    }

    if (codigoMunicipioInicio === null) {
      toast.info('Código Município de Início da CT-e não selecionado.');
      return false;
    }

    if (cidadeInicio === '') {
      toast.info('Município de Início da CT-e não selecionado.');
      return false;
    }

    if (ufInicio === '') {
      toast.info('UF do Município de Início da CT-e não selecionado.');
      return false;
    }

    if (codigoMunicipioFim === null) {
      toast.info('Código Município Fim da CT-e não selecionado.');
      return false;
    }

    if (cidadeInicio === '') {
      toast.info('Município de Fim da CT-e não selecionado.');
      return false;
    }

    if (ufInicio === '') {
      toast.info('UF do Município de Início da CT-e não selecionado.');
      return false;
    }

    if (tipoServico === 'NORMAL' && listaServicosValores.length <= 0) {
      toast.info('Para CT-e normal o valor do serviço não pode ser zero.');
      return false;
    }

    if (tpCTe === 'SUBSTITUICAO' && substituicaoCteChaveAcesso.length !== 44) {
      toast.info('Para CT-e substituição chave de acesso a substituir deve ser informada.');
      return false;
    }

    salvarRegistro();
  };

  const onHideConsultaTomador = () => {
    setShowConsultaTomador(false);
  };

  const onHideConsultaRemetente = () => {
    setShowConsultaRemetente(false);
  };

  const onHideConsultaDestinatario = () => {
    setShowConsultaDestinatario(false);
  };

  const onHideConsultaRecebedor = () => {
    setShowConsultaRecebedor(false);
  };

  const onHideConsultaExpedidor = () => {
    setShowConsultaExpedidor(false);
  };

  const onHideConsultaCte = () => {
    setShowConsultaCte(false);
  };

  const onHideConsultaNaturezaOperacao = () => {
    setShowConsultaNaturezaOperacao(false);
    getNatOps();
  };

  const childToParentTomador = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        setIdTomador(idElement);

        if (e.razaoSocial) {
          setNomeTomador(e.razaoSocial);
          setIeTomador(e.inscricaoEstadual);
        } else {
          setIdTomador(null);
          setNomeTomador('');
          setIeTomador('');
        }

        setShowConsultaTomador(false);
      } else {
        toast.warning('Tomador selecionado não pertence a empresa emitente da CT-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentRemetente = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        setIdRemetente(idElement);

        if (e.razaoSocial) {
          setNomeRemetente(e.razaoSocial);
          setIeRemetente(e.inscricaoEstadual);
        } else {
          setIdRemetente(null);
          setNomeRemetente('');
          setIeRemetente('');
        }

        setShowConsultaRemetente(false);
      } else {
        toast.warning('Remetente selecionado não pertence a empresa emitente da CT-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentDestinatario = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        setIdDestinatario(idElement);

        if (e.razaoSocial) {
          setNomeDestinatario(e.razaoSocial);
          setIeDestinatario(e.inscricaoEstadual);
        } else {
          setIdDestinatario(null);
          setNomeDestinatario('');
          setIeDestinatario('');
        }

        setShowConsultaDestinatario(false);
      } else {
        toast.warning('Destinatário selecionado não pertence a empresa emitente da CT-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentRecebedor = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        setIdRecebedor(idElement);

        if (e.razaoSocial) {
          setNomeRecebedor(e.razaoSocial);
          setIeRecebedor(e.inscricaoEstadual);
          setUfRecebedor(e.uf);
        } else {
          setIdRecebedor(null);
          setNomeRecebedor('');
          setIeRecebedor('');
          setUfRecebedor('');
        }

        setShowConsultaRecebedor(false);
      } else {
        toast.warning('Recebedor selecionado não pertence a empresa emitente da CT-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentExpedidor = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        setIdExpedidor(idElement);

        if (e.razaoSocial) {
          setNomeExpedidor(e.razaoSocial);
          setIeExpedidor(e.inscricaoEstadual);
          setUfExpedidor(e.uf);
        } else {
          setIdExpedidor(null);
          setNomeExpedidor('');
          setIeExpedidor('');
          setUfExpedidor('');
        }

        setShowConsultaExpedidor(false);
      } else {
        toast.warning('Expedidor selecionado não pertence a empresa emitente da CT-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentCte = (e) => {
    const idElement = get(e, 'id', 0);

    if (e.flag !== 'T') {
      toast.warning('CT-e não enviada não pode ser selecionada');
      return false;
    }

    if (e.codSit === 'CANCELADO') {
      toast.warning('CT-e cancelada não pode ser selecionada');
      return false;
    }

    if (e.codSit === 'DENEGADO') {
      toast.warning('CT-e denegada não pode ser selecionada');
      return false;
    }

    if (idElement > 0) {
      if (empresaCnpj === e.cnpjEmpresa.trim()) {
        if (e.chaveAcesso) {
          setComplementarChCte(e.chaveAcesso);
        } else {
          setComplementarChCte('');
        }

        setShowConsultaCte(false);
      } else {
        toast.warning('CT-e selecionado não pertence a empresa emitente da CT-e');
      }
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const childToParentNatOp = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.descricao) {
        setNatOp(e.descricao);
      }
      setShowConsultaNaturezaOperacao(false);
      getNatOps();
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const cancelEdicaoEnviada = () => {
    childToParentConsulta();
  };

  const searchNatOp = (event) => {
    setNatOp(event.query);

    const listDropdown = [];
    listaNatOps.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredNatOp(listDropdown);
  };

  const confirmCancelarDigitacaoCTe = () => {
    childToParentConsulta();
  };

  const confirmDeleteQuantidadeCarga = () => {
    const item = get(selectedQuantidadeCarga, 'item', 0);
    if (item > 0) {
      const _listaQuantidadeCarga = listaQuantidadeCarga;

      const index = _listaQuantidadeCarga.indexOf(_listaQuantidadeCarga.find(element => element.item === item));

      if (index >= 0) {
        _listaQuantidadeCarga.splice(index, 1);

        _listaQuantidadeCarga.forEach(element => {
          if (element.item > item) {
            const _index = _listaQuantidadeCarga.indexOf(element);

            _listaQuantidadeCarga[_index].item = _listaQuantidadeCarga[_index].item - 1;
          }
        });

        setListaQuantidadeCarga(_listaQuantidadeCarga);

        setShowConfirmDeleteQuantidadeCarga(false);
      }
    }
  };

  const confirmDeleteServicoValor = () => {
    const item = get(selectedServicoValor, 'item', 0);
    if (item > 0) {
      const _listaServicoValor = listaServicosValores;

      const index = _listaServicoValor.indexOf(_listaServicoValor.find(element => element.item === item));

      if (index >= 0) {
        _listaServicoValor.splice(index, 1);

        _listaServicoValor.forEach(element => {
          if (element.item > item) {
            const _index = _listaServicoValor.indexOf(element);

            _listaServicoValor[_index].item = _listaServicoValor[_index].item - 1;
          }
        });

        setListaServicosValores(_listaServicoValor);

        setShowConfirmDeleteServicoValor(false);
      }
    }
  };

  const confirmDeleteDuplicata = () => {
    const item = get(selectedDuplicata, 'item', 0);
    if (item > 0) {
      const _listaDuplicata = listaDuplicata;

      const index = _listaDuplicata.indexOf(_listaDuplicata.find(element => element.item === item));

      if (index >= 0) {
        _listaDuplicata.splice(index, 1);

        _listaDuplicata.forEach(element => {
          if (element.item > item) {
            const _index = _listaDuplicata.indexOf(element);

            _listaDuplicata[_index].item = _listaDuplicata[_index].item - 1;
          }
        });

        setListaDuplicata(_listaDuplicata);

        setShowConfirmDeleteDuplicata(false);
      }
    }
  };

  const confirmDeleteRodoviario = () => {
    const item = get(selectedRodoviario, 'item', 0);
    if (item > 0) {
      const _listaRodoviario = listaRodoviario;

      const index = _listaRodoviario.indexOf(_listaRodoviario.find(element => element.item === item));

      if (index >= 0) {
        _listaRodoviario.splice(index, 1);

        _listaRodoviario.forEach(element => {
          if (element.item > item) {
            const _index = _listaRodoviario.indexOf(element);

            _listaRodoviario[_index].item = _listaRodoviario[_index].item - 1;
          }
        });

        setListaRodoviario(_listaRodoviario);

        setShowConfirmDeleteRodoviario(false);
      }
    }
  };

  const confirmDeleteCteComplementar = () => {
    const item = get(selectedCteComplementar, 'item', 0);
    if (item > 0) {
      const _listaCteComplementar = listaCteComplementar;

      const index = _listaCteComplementar.indexOf(_listaCteComplementar.find(element => element.item === item));

      if (index >= 0) {
        _listaCteComplementar.splice(index, 1);

        _listaCteComplementar.forEach(element => {
          if (element.item > item) {
            const _index = _listaCteComplementar.indexOf(element);

            _listaCteComplementar[_index].item = _listaCteComplementar[_index].item - 1;
          }
        });

        setListaCteComplementar(_listaCteComplementar);

        setShowConfirmDeleteCteComplementar(false);
      }
    }
  };

  const confirmDeleteNfRef = () => {
    const item = get(selectedNfRef, 'item', 0);
    if (item > 0) {
      const _listaNfRef = listaNfRef;

      const index = _listaNfRef.indexOf(_listaNfRef.find(element => element.item === item));

      if (index >= 0) {
        _listaNfRef.splice(index, 1);

        _listaNfRef.forEach(element => {
          if (element.item > item) {
            const _index = _listaNfRef.indexOf(element);

            _listaNfRef[_index].item = _listaNfRef[_index].item - 1;
          }
        });

        setListaNfRef(_listaNfRef);

        setShowConfirmDeleteNfRef(false);
      }
    }
  };

  const cancelDeleteQuantidadeCarga = () => {
    setShowConfirmDeleteQuantidadeCarga(false);
  };

  const cancelDeleteNfRef = () => {
    setShowConfirmDeleteNfRef(false);
  };

  const cancelDeleteServicoValor = () => {
    setShowConfirmDeleteServicoValor(false);
  };

  const cancelDeleteDuplicata = () => {
    setShowConfirmDeleteDuplicata(false);
  };

  const cancelDeleteRodoviario = () => {
    setShowConfirmDeleteRodoviario(false);
  };

  const cancelDeleteCteComplementar = () => {
    setShowConfirmDeleteCteComplementar(false);
  };

  const cancelCancelarDigitacaoCTe = () => {
    setShowConfirmCancelarDigitacaoCTe(false);
  };

  const handleCancel = () => {
    setShowConfirmCancelarDigitacaoCTe(true);
  };

  const confirmDialogFooterCancelarDigitacaoCTe = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmCancelarDigitacaoCTe} />
      <Button label="Não" icon="pi pi-times" onClick={cancelCancelarDigitacaoCTe} />
    </div>
  );

  const confirmDialogFooterDeleteQuantidadeCarga = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteQuantidadeCarga} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteQuantidadeCarga} />
    </div>
  );

  const confirmDialogFooterDeleteServicoValor = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteServicoValor} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteServicoValor} />
    </div>
  );

  const confirmDialogFooterDeleteDuplicata = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteDuplicata} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteDuplicata} />
    </div>
  );

  const confirmDialogFooterDeleteRodoviario = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteRodoviario} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteRodoviario} />
    </div>
  );

  const confirmDialogFooterDeleteCteComplementar = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteCteComplementar} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteCteComplementar} />
    </div>
  );

  const confirmDeleteFooterNfRef = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteNfRef} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteNfRef} />
    </div>
  );

  function limparDadosDestinatario() {
    setIdDestinatario(null);
    setNomeDestinatario('');
    setIeDestinatario('');
  }

  function limparDadosRemetente() {
    setIdRemetente(null);
    setNomeRemetente('');
    setIeRemetente('');
  }

  function limparDadosRecebedor() {
    setIdRecebedor(null);
    setNomeRecebedor('');
    setIeRecebedor('');
    setUfRecebedor('');
  }

  function limparDadosExpedidor() {
    setIdExpedidor(null);
    setNomeExpedidor('');
    setIeExpedidor('');
    setUfExpedidor('');
  }

  const limparCabecalhoNfReferenciada = async () => {
    setNfRefDataEmissao(null);
    setNfRefSerie('');
    setNfRefNumeroNF('');
    setNfRefPeso(0);
    setNfRefValorTotal(0);
  };

  const limparDadosNfReferenciadaNFeCTe = () => {
    setNfRefChaveAcesso('');
    setNfRefSuframa('');
    setNfRefDataEntrega(null);
  };

  const limparDadosNfReferenciadaAvulsaProdutor = () => {
    setNfRefNumeroRomaneio('');
    setNfRefNumeroPedido('');
    setNfRefModeloNfProdutor('');
    setNfRefCfopPredominante('');
    setNfRefValorBcIcms(0);
    setNfRefValorIcms(0);
    setNfRefValorBcIcmsSt(0);
    setNfRefValorIcmsSt(0);
    setNfRefValorTotalProdutos(0);
  };

  const limparDadosNfReferenciadaOutros = () => {
    setNfRefModeloNfOutros('');
    setNfRefDescricao('');
  };

  const limparDadosNfReferenciada = () => {
    limparCabecalhoNfReferenciada();
    limparDadosNfReferenciadaNFeCTe();
    limparDadosNfReferenciadaAvulsaProdutor();
    limparDadosNfReferenciadaOutros();
  };

  const limparDadosQuantidadeCarga = () => {
    setCargaUnidade(null);
    setCargaTipoMedida(null);
    setCargaQuantidadeCarga(0);
  };

  const limparDadosServicoValor = () => {
    setServicoDescricao('');
    setServicoValor(0);
  };

  const limparDadosDuplicata = () => {
    setDuplicataData(null);
    setDuplicataNumero('');
    setDuplicataValor(0);
  };

  const limparDadosRodoviario = () => {

  };

  const limparDadosCteComplementar = () => {
    setComplementarChCte('');
  };

  const onHideCadastroNfRef = () => {
    limparDadosNfReferenciada();
    setShowCadastroNfRef(false);
  };

  const onHideCadastroQuantidadeCarga = () => {
    setShowCadastroQuantidadeCarga(false);
  };

  const onHideCadastroServicoValor = () => {
    setShowCadastroServicoValor(false);
  };

  const onHideCadastroDuplicata = () => {
    setShowCadastroDuplicata(false);
  };

  const onHideCadastroRodoviario = () => {
    setShowCadastroRodoviario(false);
  };

  const onHideCadastroCteComplementar = () => {
    setShowCadastroCteComplementar(false);
  };

  useEffect(() => {
    const tabAtual = tabActiveIndex;
    function atualizaTab() {
      setTabActiveIndex(tabAtual);
    }
    atualizaTab();
  }, [tabActiveIndex]);

  useEffect(() => {
    const chaveAtual = nfRefChaveAcesso;

    function atualizaNfRefMod() {
      const modelo = chaveAtual.substring(20, 22);
      if (modelo === '55' || modelo === '57') {
        setNfRefMod(modelo);
      } else {
        setNfRefMod('');
      }
    }

    if (nfRefChaveAcesso.length === 44) {
      atualizaNfRefMod();
    } else {
      setNfRefMod('');
    }
  }, [nfRefChaveAcesso]);

  useEffect(() => {
    const modelo = nfRefModeloNfProdutor;

    function atualizaNfRefModProdutor() {
      setNfRefModeloNfProdutor(modelo);
    }

    atualizaNfRefModProdutor();
  }, [nfRefModeloNfProdutor]);

  useEffect(() => {
    const modelo = nfRefModeloNfOutros;

    function atualizaNfRefModOutros() {
      setNfRefModeloNfOutros(modelo);
    }

    atualizaNfRefModOutros();
  }, [nfRefModeloNfOutros]);

  const handleOkQuantidadeCarga = async () => {
    if (cargaUnidade === null || cargaUnidade === '') {
      toast.warning('Unidade da Carga deve ser informada.');
      return false;
    }

    if (cargaTipoMedida === null || cargaTipoMedida === '') {
      toast.warning('Tipo Medida da Carga deve ser informada.');
      return false;
    }

    if (cargaQuantidadecarga <= 0) {
      toast.warning('Quantidade de Carga deve ser informada.');
      return false;
    }

    const _listaQuantidadeCarga = listaQuantidadeCarga;

    let item = 0;
    listaQuantidadeCarga.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoQuantidadeCarga && editandoQuantidadeCarga > 0) {
      item = editandoQuantidadeCarga;

      const index = _listaQuantidadeCarga.indexOf(_listaQuantidadeCarga.find(element => element.item === editandoQuantidadeCarga));

      if (index >= 0) {
        _listaQuantidadeCarga.splice(index, 1);
      }
    }

    _listaQuantidadeCarga.push({
      item,
      cUnid: cargaUnidade,
      tpMed: cargaTipoMedida,
      qCarga: cargaQuantidadecarga,
    });

    // console.log(_listaQuantidadeCarga);

    setListaQuantidadeCarga(_listaQuantidadeCarga);

    limparDadosQuantidadeCarga();
    setShowCadastroQuantidadeCarga(false);
  };

  const handleOkServicoValor = async () => {
    if (servicoDescricao.length <= 0) {
      toast.warning('Descrição do serviço deve ser informada');
      return false;
    }

    if (servicoValor <= 0) {
      toast.warning('Valor do serviço deve ser informado');
      return false;
    }

    const _listaServicoValor = listaServicosValores;

    let item = 0;
    listaServicosValores.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoServicoValor && editandoServicoValor > 0) {
      item = editandoServicoValor;

      const index = _listaServicoValor.indexOf(_listaServicoValor.find(element => element.item === editandoServicoValor));

      if (index >= 0) {
        _listaServicoValor.splice(index, 1);
      }
    }

    _listaServicoValor.push({
      item,
      descricao: servicoDescricao,
      valor: servicoValor,
    });

    // console.log(_listaServicoValor);

    setListaServicosValores(_listaServicoValor);

    limparDadosServicoValor();
    setShowCadastroServicoValor(false);
  };

  const handleOkDuplicata = async () => {
    if (duplicataData === null) {
      toast.warning('Data da duplicata deve ser informada.');
      return false;
    }
    if (duplicataNumero === '') {
      toast.warning('Número da duplicata deve ser informado.');
      return false;
    }
    if (duplicataValor <= 0) {
      toast.warning('Valor da duplicata deve ser informado.');
      return false;
    }

    const _listaDuplicata = listaDuplicata;

    let item = 0;
    _listaDuplicata.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoDuplicata && editandoDuplicata > 0) {
      item = editandoDuplicata;

      const index = _listaDuplicata.indexOf(_listaDuplicata.find(element => element.item === editandoDuplicata));

      if (index >= 0) {
        _listaDuplicata.splice(index, 1);
      }
    }

    _listaDuplicata.push({
      item,
      duplicataData: formataDataMoment(duplicataData, '-'),
      numero: duplicataNumero,
      valor: duplicataValor,
    });

    setListaDuplicata(_listaDuplicata);

    limparDadosDuplicata();
    setShowCadastroDuplicata(false);
  };

  const handleOkRodoviario = async () => {
    if (rodDataEmissao === null) {
      toast.warning('Data Emissão deve ser informada');
      return false;
    }

    if (rodNumero <= 0) {
      toast.warning('Número deve ser informado');
      return false;
    }

    if (rodCnpj.length < 14) {
      toast.warning('CNPJ deve ser informado');
      return false;
    }

    if (rodIE.length < 11) {
      toast.warning('Inscricao deve ser informada');
      return false;
    }

    if (rodUF === '' || rodUF.length < 2) {
      toast.warning('UF deve ser informado');
      return false;
    }

    const _listaRodoviario = listaRodoviario;

    let item = 0;
    _listaRodoviario.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoRodoviario && editandoRodoviario > 0) {
      item = editandoRodoviario;

      const index = _listaRodoviario.indexOf(_listaRodoviario.find(element => element.item === editandoRodoviario));

      if (index >= 0) {
        _listaRodoviario.splice(index, 1);
      }
    }

    _listaRodoviario.push({
      item,
      rodoviarioDataEmissao: formataDataMoment(rodDataEmissao, '-'),
      numero: rodNumero,
      serie: rodSerie,
      cnpj: rodCnpj,
      ie: rodIE,
      codigoInterno: rodCodigoInterno,
      uf: rodUF,
      telefone: rodTelefone,
    });

    setListaRodoviario(_listaRodoviario);

    limparDadosRodoviario();
    setShowCadastroRodoviario(false);
  };

  const handleOkCteComplementar = async () => {
    if (complementarChCte === '') {
      toast.warning('Chave do CT-e complementar deve ser informada');
      return false;
    }

    if (complementarChCte.length < 44) {
      toast.warning('Chave do CT-e complementar deve conter 44 dígitos');
      return false;
    }

    const _listaCteComplementar = listaCteComplementar;

    let existeCteNaLista = false;

    _listaCteComplementar.forEach(element => {
      if (element.chaveAcesso === complementarChCte) {
        existeCteNaLista = true;
      }
    });

    if (existeCteNaLista) {
      toast.warning('CT-e Complementar já incluída');
      return false;
    }

    let item = 0;
    _listaCteComplementar.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoCteComplementar && editandoCteComplementar > 0) {
      item = editandoCteComplementar;

      const index = _listaCteComplementar.indexOf(_listaCteComplementar.find(element => element.item === editandoCteComplementar));

      if (index >= 0) {
        _listaCteComplementar.splice(index, 1);
      }
    }

    _listaCteComplementar.push({
      item,
      chaveAcesso: complementarChCte,
    });

    setListaCteComplementar(_listaCteComplementar);

    limparDadosCteComplementar();
    setShowCadastroCteComplementar(false);
  };

  const handleOkNfRef = async () => {
    if (nfRefDataEmissao == null) {
      toast.warning('Data Emissão Referenciado deve ser informada');
      return;
    }

    if (nfRefSerie === '' && nfRefModeloNfOutros !== '99') {
      toast.warning('Serie do Doc. Referenciado deve ser informada');
      return;
    }

    if (nfRefNumeroNF === '' && nfRefModeloNfOutros !== '99') {
      toast.warning('Número do Doc. Referenciado deve ser informada');
      return;
    }

    if (nfRefValorTotal <= 0 && nfRefModeloNfOutros !== '99') {
      toast.warning('Valor total da Nota Fiscal deve ser informado');
      return;
    }

    if (nfRefPeso <= 0 && nfRefModeloNfOutros !== '99') {
      toast.warning('Peso do Doc. Referenciado deve deve informado');
      return;
    }

    if (nfRefModeloNfProdutor === null && nfRefModeloNfOutros === null && nfRefChaveAcesso === '') {
      toast.warning('Chave de Acesso de NF-e/CT-e ou modelos Avulsa/Produtor ou modelo outros deve ser informado');
      return;
    }

    const _listaNfRef = listaNfRef;

    let item = 0;
    listaNfRef.forEach(element => {
      if (element.item > item) {
        item = element.item;
      }
    });
    item = item + 1;

    if (editandoNfRef && editandoNfRef > 0) {
      item = editandoNfRef;

      const index = _listaNfRef.indexOf(_listaNfRef.find(element => element.item === editandoNfRef));

      if (index >= 0) {
        _listaNfRef.splice(index, 1);
      }
    }

    _listaNfRef.push({
      item,
      dEmi: formataDataMoment(nfRefDataEmissao, '-'),
      serie: nfRefSerie,
      mod: nfRefMod, // pode ser de nfe, cte, produtos, avuso e outros
      nDoc: nfRefNumeroNF,
      peso: nfRefPeso,
      vNF: nfRefValorTotal,
      // nfe cte
      chave: nfRefChaveAcesso,
      pin: nfRefSuframa,
      // dPrev: formataDataMoment(nfRefDataEntrega, '-'),
      // avulsa/produtor
      nRoma: nfRefNumeroRomaneio,
      nPed: nfRefNumeroPedido,
      nCFOP: nfRefCfopPredominante,
      vBC: nfRefValorBcIcms,
      vICMS: nfRefValorIcms,
      vBCST: nfRefValorBcIcmsSt,
      vST: nfRefValorIcmsSt,
      vProd: nfRefValorTotalProdutos,
      produtor: nfRefModeloNfProdutor,
      // outros
      outrosTipo: nfRefModeloNfOutros,
      outrosDescricao: nfRefDescricao,
    });

    setListaNfRef(_listaNfRef);

    limparDadosNfReferenciada();
    setShowCadastroNfRef(false);
  };

  const handleEditQuantidadeCarga = (e) => {
    e.preventDefault();

    const item = get(selectedQuantidadeCarga, 'item', 0);

    if (item > 0) {
      const _quantidadeCarga = listaQuantidadeCarga.find(element => element.item === item);

      if (!_quantidadeCarga) {
        toast.warning('Por favor, selecione a Quantidade de Carga para edição');
        return;
      }

      setEditandoQuantidadeCarga(item);

      setCargaUnidade(_quantidadeCarga.cUnid);
      setCargaTipoMedida(_quantidadeCarga.tpMed);
      setCargaQuantidadeCarga(_quantidadeCarga.qCarga);

      setShowCadastroQuantidadeCarga(true);
    }
  };

  const handleEditServicoValor = (e) => {
    e.preventDefault();

    const item = get(selectedServicoValor, 'item', 0);

    if (item > 0) {
      const _servico = listaServicosValores.find(element => element.item === item);

      if (!_servico) {
        toast.warning('Por favor, selecione a Serviço valor para edição');
        return;
      }

      setEditandoServicoValor(item);

      setServicoDescricao(_servico.descricao);
      setServicoValor(_servico.valor);

      setShowCadastroServicoValor(true);
    }
  };

  const handleEditDuplicata = (e) => {
    e.preventDefault();

    const item = get(selectedDuplicata, 'item', 0);

    if (item > 0) {
      const _duplicata = listaDuplicata.find(element => element.item === item);

      if (!_duplicata) {
        toast.warning('Por favor, selecione a Duplicata para edição');
        return;
      }

      setEditandoDuplicata(item);

      setDuplicataData(moment(_duplicata.duplicataData, 'DD-MM-YYYY').toDate());
      setDuplicataNumero(_duplicata.numero);
      setDuplicataValor(_duplicata.valor);

      setShowCadastroDuplicata(true);
    }
  };

  const handleEditRodoviario = (e) => {
    e.preventDefault();

    const item = get(selectedRodoviario, 'item', 0);

    if (item > 0) {
      const _rodoviario = listaRodoviario.find(element => element.item === item);

      if (!_rodoviario) {
        toast.warning('Por favor, selecione a Rodoviário para edição');
        return;
      }

      setEditandoRodoviario(item);

      setRodDataEmissao(moment(_rodoviario.rodoviarioDataEmissao, 'DD-MM-YYYY').toDate());
      setRodNumero(_rodoviario.numero);
      setRodSerie(_rodoviario.serie);
      setRodCnpj(_rodoviario.cnpj);
      setRodIE(_rodoviario.ie);
      setRodTelefone(_rodoviario.telefone);
      setRodCodigoInterno(_rodoviario.codigoInterno);
      setRodUF(_rodoviario.uf);

      setShowCadastroRodoviario(true);
    }
  };

  const handleInclusaoCteComplementar = (e) => {
    e.preventDefault();

    if (tpCTe === 'NORMAL') {
      toast.warning('CT-e Complementar não permitida para finalidade normal');
      return;
    }

    setEditandoCteComplementar(0);
    limparDadosCteComplementar();
    setShowCadastroCteComplementar(true);
  };

  const handleEditCteComplementar = (e) => {
    e.preventDefault();

    const item = get(selectedCteComplementar, 'item', 0);

    if (item > 0) {
      const _complementar = listaCteComplementar.find(element => element.item === item);

      if (!_complementar) {
        toast.warning('Por favor, selecione a CT-e Complementar para edição');
        return;
      }

      setEditandoCteComplementar(item);

      setRodNumero(_complementar.chaveAcesso);

      setShowCadastroCteComplementar(true);
    }
  };

  const handleEditNfRef = (e) => {
    e.preventDefault();

    const item = get(selectedNfRef, 'item', 0);

    if (item > 0) {
      const _nfRefSelecionado = listaNfRef.find(element => element.item === item);

      if (!_nfRefSelecionado) {
        toast.warning('Por favor, selecione o Doc. Referenciado para edição');
        return;
      }

      setEditandoNfRef(item);

      setNfRefDataEmissao(moment(_nfRefSelecionado.dEmi, 'DD-MM-YYYY').toDate());
      setNfRefSerie(_nfRefSelecionado.serie);
      setNfRefNumeroNF(_nfRefSelecionado.nDoc);
      setNfRefPeso(_nfRefSelecionado.peso);
      setNfRefValorTotal(_nfRefSelecionado.vnf);
      setNfRefChaveAcesso(_nfRefSelecionado.chave);
      setNfRefSuframa(_nfRefSelecionado.pin);
      setNfRefDataEntrega(moment(_nfRefSelecionado.dPrev, 'DD-MM-YYYY').toDate());
      setNfRefCfopPredominante(_nfRefSelecionado.nCFOP);
      setNfRefNumeroRomaneio(_nfRefSelecionado.nRoma);
      setNfRefNumeroPedido(_nfRefSelecionado.nPed);
      setNfRefValorBcIcms(_nfRefSelecionado.vBC);
      setNfRefValorIcms(_nfRefSelecionado.vICMS);
      setNfRefValorBcIcmsSt(_nfRefSelecionado.vBCST);
      setNfRefValorIcmsSt(_nfRefSelecionado.vST);
      setNfRefValorTotalProdutos(_nfRefSelecionado.vProd);
      setNfRefValorTotal(_nfRefSelecionado.vNF);

      setNfRefMod(_nfRefSelecionado.mod);
      setNfRefModeloNfProdutor(_nfRefSelecionado.produtor);
      setNfRefModeloNfOutros(_nfRefSelecionado.outrosTipo);
      setNfRefDescricao(_nfRefSelecionado.outrosDescricao);

      setShowCadastroNfRef(true);
    }
  };

  const handleDeleteNfRef = (e) => {
    e.preventDefault();

    const item = get(selectedNfRef, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaNfRef.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o Documento Referenciado para exclusão');
        return;
      }

      setShowConfirmDeleteNfRef(true);
    } else {
      toast.warning('Por favor, selecione o Documento Referenciado para exclusão');
    }
  };

  const handleDeleteQuantidadeCarga = (e) => {
    e.preventDefault();

    const item = get(selectedQuantidadeCarga, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaQuantidadeCarga.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione a Quantidade de Cargapara exclusão');
        return;
      }

      setShowConfirmDeleteQuantidadeCarga(true);
    } else {
      toast.warning('Por favor, selecione a Quantidade de Carga para exclusão');
    }
  };

  const handleDeleteServicoValor = (e) => {
    e.preventDefault();

    const item = get(selectedServicoValor, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaServicosValores.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione a Serviço Valor para exclusão');
        return;
      }

      setShowConfirmDeleteServicoValor(true);
    } else {
      toast.warning('Por favor, selecione o Serviço Valor para exclusão');
    }
  };

  const handleDeleteDuplicata = (e) => {
    e.preventDefault();

    const item = get(selectedDuplicata, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaDuplicata.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione a Serviço Valor para exclusão');
        return;
      }

      setShowConfirmDeleteDuplicata(true);
    } else {
      toast.warning('Por favor, selecione a Duplicata para exclusão');
    }
  };

  const handleDeleteRodoviario = (e) => {
    e.preventDefault();

    const item = get(selectedRodoviario, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaRodoviario.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione a Serviço Valor para exclusão');
        return;
      }

      setShowConfirmDeleteRodoviario(true);
    } else {
      toast.warning('Por favor, selecione a Rodoviário para exclusão');
    }
  };

  const handleDeleteCteComplementar = (e) => {
    e.preventDefault();

    const item = get(selectedCteComplementar, 'item', 0);

    if (item > 0) {
      const _itemSelecionado = listaCteComplementar.find(element => element.item === item);

      if (!_itemSelecionado) {
        toast.warning('Por favor, selecione o CT-e Complementar para exclusão');
        return;
      }

      setShowConfirmDeleteCteComplementar(true);
    } else {
      toast.warning('Por favor, selecione o CT-e Complementar para exclusão');
    }
  };

  const onBlurCodigoMunicipioInicio = (e) => {
    const listDropdown = [];

    listaMunicipio.forEach(element => {
      if (element.codigo !== undefined && element.codigo === e) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setCidadeInicio('');
    setUfInicio('');

    if (listDropdown.length > 0) {
      setCidadeInicio(get(listDropdown[0], 'label', ''));
      setUfInicio(get(listDropdown[0], 'uf', ''));
    }
  };

  const onBlurCodigoMunicipioFim = (e) => {
    const listDropdown = [];

    listaMunicipio.forEach(element => {
      if (element.codigo !== undefined && element.codigo === e) {
        listDropdown.push({ label: element.label, value: element.value, codigo: element.codigo, uf: element.uf });
      }
    });

    setCidadeFim('');
    setUfFim('');

    if (listDropdown.length > 0) {
      setCidadeFim(get(listDropdown[0], 'label', ''));
      setUfFim(get(listDropdown[0], 'uf', ''));
    }
  };

  const handleChangeCidadeInicio = (event) => {
    const codigo = get(event.value, 'codigo', '');

    if (codigo !== '' && codigo.length === 7) {
      setCodigoMunicipioInicio(codigo);
      onBlurCodigoMunicipioInicio(codigo);
    } else {
      setCidadeInicio(event.value);
    }
  };

  const handleChangeCidadeFim = (event) => {
    const codigo = get(event.value, 'codigo', '');

    if (codigo !== '' && codigo.length === 7) {
      setCodigoMunicipioFim(codigo);
      onBlurCodigoMunicipioFim(codigo);
    } else {
      setCidadeFim(event.value);
    }
  };

  const titulo = () => (id && !clonar ? 'CT-e - Alteração' : 'CT-e - Inclusão');

  return (

    <div>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Consulta de Tomador"
        visible={showConsultaTomador}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaTomador()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParentTomador} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Consulta de Remetente"
        visible={showConsultaRemetente}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaRemetente()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParentRemetente} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Consulta de Destinatário"
        visible={showConsultaDestinatario}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaDestinatario()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParentDestinatario} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Consulta de Recebedor"
        visible={showConsultaRecebedor}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaRecebedor()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParentRecebedor} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Consulta de Expedidor"
        visible={showConsultaExpedidor}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaExpedidor()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParentExpedidor} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Consulta de Ct-e"
        visible={showConsultaCte}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaCte()}
      >
        <ConsultaCte menuMode={false} childToParent={childToParentCte} empresaCnpj={empresaCnpj} />
      </Dialog>

      <Dialog
        header="Consulta de Natureza da Operação"
        visible={showConsultaNaturezaOperacao}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaNaturezaOperacao()}
      >
        <ConsultaNaturezaOperacao menuMode={false} childToParent={childToParentNatOp} />
      </Dialog>

      <Dialog
        header="Confirmação Cancelamento da digitação da CTe"
        visible={showConfirmCancelarDigitacaoCTe}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterCancelarDigitacaoCTe}
        onHide={() => showConfirmCancelarDigitacaoCTe(false)}
      >
        <p>
          Deseja realmente cancelar a digitação da CT-e?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteQuantidadeCarga}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDeleteQuantidadeCarga}
        onHide={() => setShowConfirmDeleteQuantidadeCarga(false)}
      >
        <p>
          Excluir a Quantidade de Carga?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteDuplicata}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDeleteDuplicata}
        onHide={() => setShowConfirmDeleteDuplicata(false)}
      >
        <p>
          Excluir a duplicata?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteRodoviario}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDeleteRodoviario}
        onHide={() => setShowConfirmDeleteRodoviario(false)}
      >
        <p>
          Excluir a inclusão rodoviária?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteCteComplementar}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDeleteCteComplementar}
        onHide={() => setShowConfirmDeleteCteComplementar(false)}
      >
        <p>
          Excluir o CT-e Complementar?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteServicoValor}
        style={{ width: '50vw' }}
        footer={confirmDialogFooterDeleteServicoValor}
        onHide={() => setShowConfirmDeleteServicoValor(false)}
      >
        <p>
          Excluir a Quantidade de Carga?
        </p>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={showConfirmDeleteNfRef}
        style={{ width: '50vw' }}
        footer={confirmDeleteFooterNfRef}
        onHide={() => setShowConfirmDeleteNfRef(false)}
      >
        <p>
          Excluir a Nota Fiscal Referenciada?
        </p>
      </Dialog>

      <Dialog
        header="Quantidades de Carga"
        visible={showCadastroQuantidadeCarga}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroQuantidadeCarga()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Unidade Medida*
              </Input155px>
              <Dropdown
                options={listaCargaCUnid}
                value={cargaUnidade}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setCargaUnidade(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Medida*
              </Input155px>
              <Dropdown
                options={listaCargaTpMed}
                value={cargaTipoMedida}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setCargaTipoMedida(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Quantidade*
              </Input155px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                minFractionDigits={4}
                maxFractionDigits={4}
                value={cargaQuantidadecarga}
                onValueChange={e => setCargaQuantidadeCarga(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkQuantidadeCarga}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroQuantidadeCarga(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Serviço e Valor"
        visible={showCadastroServicoValor}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroServicoValor()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Serviço*
              </Input155px>
              <Dropdown
                options={listaServicoTipo}
                value={servicoDescricao}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setServicoDescricao(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Valor*
              </Input155px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                minFractionDigits={4}
                maxFractionDigits={4}
                value={servicoValor}
                onValueChange={e => setServicoValor(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkServicoValor}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroServicoValor(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Duplicatas"
        visible={showCadastroDuplicata}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroDuplicata()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data Duplicata*
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={duplicataData}
                onChange={(e) => setDuplicataData(e.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Número*
              </Input100px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={9}
                value={duplicataNumero}
                onChange={e => setDuplicataNumero(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Valor*
              </Input155px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                minFractionDigits={4}
                maxFractionDigits={4}
                value={duplicataValor}
                onValueChange={e => setDuplicataValor(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkDuplicata}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroDuplicata(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Rodoviário"
        visible={showCadastroRodoviario}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroRodoviario()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data Emissão*
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={rodDataEmissao}
                onChange={(e) => setRodDataEmissao(e.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Número*
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={6}
                value={rodNumero}
                onChange={e => setRodNumero(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Série
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={3}
                value={rodSerie}
                onChange={e => setRodSerie(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                CNPJ*
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={14}
                value={rodCnpj}
                onChange={e => setRodCnpj(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Inscrição Estadual*
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={14}
                value={rodIE}
                onChange={e => setRodIE(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                UF*
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={2}
                value={rodUF}
                onChange={e => setRodUF(e.target.value.toUpperCase())}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-8">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Código Interno
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={10}
                value={rodCodigoInterno}
                onChange={e => setRodCodigoInterno(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Telefone
              </Input155px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={14}
                value={rodTelefone}
                onChange={e => setRodTelefone(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkRodoviario}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroRodoviario(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="CT-e Complementar"
        visible={showCadastroCteComplementar}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroCteComplementar()}
      >
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Chave do CT-e a complementar
              </Input200px>
              <InputText
                maxLength={44}
                minLength={44}
                value={complementarChCte}
                onChange={e => setComplementarChCte(e.target.value)}
              />
              <Button
                icon="pi pi-search"
                className="p-button-warning"
                onClick={() => setShowConsultaCte(true)}
              />
              <Button
                icon="pi pi-trash"
                className="p-button-secondary"
                onClick={() => limparDadosCteComplementar()}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleOkCteComplementar}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroCteComplementar(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="CT-e - Documento Fiscal Referenciado"
        visible={showCadastroNfRef}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastroNfRef()}
      >
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data Emissão*
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={nfRefDataEmissao}
                onChange={(e) => setNfRefDataEmissao(e.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Série*
              </Input100px>
              <InputText
                onFocus={(e) => e.target.select()}
                minLength={1}
                maxLength={3}
                value={nfRefSerie}
                onChange={e => setNfRefSerie(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Número*
              </Input100px>
              <InputText
                onFocus={(e) => e.target.select()}
                maxLength={9}
                value={nfRefNumeroNF}
                onChange={e => setNfRefNumeroNF(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Peso Total em KG
              </Input200px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                maxFractionDigits={0}
                value={nfRefPeso}
                onValueChange={e => setNfRefPeso(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-9">
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Valor Total Nota fiscal
              </Input200px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={nfRefValorTotal}
                onValueChange={e => setNfRefValorTotal(e.target.value)}
              />
            </div>
          </div>
        </div>
        <TabView
          activeIndex={tabActiveIndex}
          onTabChange={(e) => setTabActiveIndex(e.index)}
        >
          <TabPanel header="NF-e/CT-e ">
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Chave Acesso*
                  </Input200px>
                  <InputText
                    onFocus={(e) => e.target.select()}
                    maxLength={44}
                    value={nfRefChaveAcesso}
                    onChange={e => setNfRefChaveAcesso(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    PIN Suframa
                  </Input200px>
                  <InputText
                    onFocus={(e) => e.target.select()}
                    maxLength={44}
                    value={nfRefSuframa}
                    onChange={e => setNfRefSuframa(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Data Entrega
                  </Input155px>
                  <Calendar
                    id="mask"
                    showIcon
                    mask="99/99/9999"
                    dateFormat="dd/mm/yy"
                    showButtonBar
                    showOnFocus={false}
                    locale="pt-BR"
                    value={nfRefDataEntrega}
                    onChange={(e) => setNfRefDataEntrega(e.value)}
                  />
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Avulsa/Produtor">
            <div className="row form-elo">
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Número Romaneio
                  </Input200px>
                  <InputText
                    onFocus={(e) => e.target.select()}
                    maxLength={44}
                    value={nfRefNumeroRomaneio}
                    onChange={e => setNfRefNumeroRomaneio(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Número Pedido
                  </Input200px>
                  <InputText
                    onFocus={(e) => e.target.select()}
                    maxLength={44}
                    value={nfRefNumeroPedido}
                    onChange={e => setNfRefNumeroPedido(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Modelo Nota Fiscal*
                  </Input155px>
                  <Dropdown
                    options={listaModeloNfProdutor}
                    value={nfRefModeloNfProdutor}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => setNfRefModeloNfProdutor(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    CFOP Predominante*
                  </Input200px>
                  <InputText
                    onFocus={(e) => e.target.select()}
                    maxLength={44}
                    value={nfRefCfopPredominante}
                    onChange={e => setNfRefCfopPredominante(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Valor BC do ICMS
                  </Input200px>
                  <InputNumber
                    onFocus={(e) => e.target.select()}
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={nfRefValorBcIcms}
                    onValueChange={e => setNfRefValorBcIcms(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Valor ICMS
                  </Input200px>
                  <InputNumber
                    onFocus={(e) => e.target.select()}
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={nfRefValorIcms}
                    onValueChange={e => setNfRefValorIcms(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Valor BC do ICMS ST
                  </Input200px>
                  <InputNumber
                    onFocus={(e) => e.target.select()}
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={nfRefValorBcIcmsSt}
                    onValueChange={e => setNfRefValorBcIcmsSt(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Valor ICMS ST
                  </Input200px>
                  <InputNumber
                    onFocus={(e) => e.target.select()}
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={nfRefValorIcmsSt}
                    onValueChange={e => setNfRefValorIcmsSt(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Valor Total dos Produtos
                  </Input200px>
                  <InputNumber
                    onFocus={(e) => e.target.select()}
                    mode="currency"
                    inputId="currency-br"
                    currency="BRL"
                    locale="pt-BR"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    value={nfRefValorTotalProdutos}
                    onValueChange={e => setNfRefValorTotalProdutos(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Outros">
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Modelo Nota Fiscal Outros*
                  </Input200px>
                  <Dropdown
                    options={listaModeloNfOutros}
                    value={nfRefModeloNfOutros}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => setNfRefModeloNfOutros(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-12">
                <div className="p-inputgroup">
                  <Input200px className="p-inputgroup-addon">
                    Descrição
                  </Input200px>
                  <InputText
                    maxLength={150}
                    value={nfRefDescricao}
                    onChange={e => setNfRefDescricao(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>

        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              title="Ok Doc. fiscal Referenciado"
              type="button"
              className="btn btn-success"
              onClick={handleOkNfRef}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroNfRef(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}>{titulo()}</h6>
        </div>
        <div className="row form-elo">
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Modelo
              </Input100px>
              <Dropdown
                // disabled
                options={listaModelo}
                value={mod}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setMod(e.target.value)}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Série*
              </Input100px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                maxFractionDigits={0}
                value={serie}
                onValueChange={e => {
                  setSerie(e.target.value);
                  propsTipoMovimentacao !== 'entrada' ? setUltimoNumero(e.target.value) : '';
                }}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Número*
              </Input100px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                maxFractionDigits={0}
                value={numeroCt}
                onValueChange={e => setNumeroCt(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Data Emissão*
              </Input100px>
              <Calendar
                id="mask"
                showIcon
                showTime
                hourFormat="24"
                showSeconds
                mask="99/99/9999 99:99:99"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={dhEmi}
                onChange={(e) => setDhEmi(e.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Finalidade
              </Input100px>
              <Dropdown
                options={listaTipo}
                value={tpCTe}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTpCTe(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Tipo
              </Input100px>
              <Dropdown
                disabled
                options={listaTipoMovimentacao}
                value={emissaoPropria}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setEmissaoPropria(e.target.value)}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                CFOP*
              </Input100px>
              <AutoComplete
                value={cfop}
                maxLength={4}
                suggestions={filteredCfop}
                completeMethod={searchCfop}
                field="label"
                dropdown
                forceSelection
                onChange={(e) => setCfop(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Tomador
              </Input155px>
              <Dropdown
                disabled={disableToCteOS}
                options={listaTipoTomador}
                value={tipoTomador}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTipoTomador(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Serviço
              </Input155px>
              <Dropdown
                options={listaTipoServico}
                value={tipoServico}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTipoServico(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Natureza da Operação*
              </Input155px>
              <AutoComplete
                value={natOp}
                minLength={1}
                maxLength={60}
                suggestions={filteredNatOp}
                completeMethod={searchNatOp}
                field="label"
                dropdown
                forceSelection
                onChange={(e) => setNatOp(e.target.value)}
              />
              <Button
                icon="pi pi-search"
                className="p-button-warning"
                onClick={() => setShowConsultaNaturezaOperacao(true)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Código Situação
              </Input155px>
              <Dropdown
                options={listaSituacaoDocumento}
                value={codSit}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setCodSit(e.target.value)}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Retira
              </Input155px>
              <ToggleButton
                disabled={disableToCteOS}
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={retira}
                onChange={(e) => setRetira(e.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo Emissão
              </Input155px>
              <Dropdown
                options={listaTipoEmissao}
                value={tpEmis}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setTpEmis(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Modalidade
              </Input155px>
              <Dropdown
                disabled
                options={listaModalidade}
                value={modalidade}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setModalidade(e.target.value)}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Globalizado
              </Input155px>
              <ToggleButton
                disabled={disableToCteOS}
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={globalizado}
                onChange={(e) => setGlobalizado(e.value)}
              />
            </div>
          </div>
        </div>

        <div className="row form-elo">
          <TabView>
            <TabPanel header="Participantes">
              <div className="row form-elo">
                <div className="col-7">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Tomador*
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={255}
                      value={nomeTomador}
                      onChange={e => setNomeTomador(e.target.value)}
                    />
                    <Button
                      icon="pi pi-search"
                      className="p-button-warning"
                      onClick={() => setShowConsultaTomador(true)}
                    />

                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Inscr. Estadual
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ieTomador}
                      onChange={e => setIeTomador(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-7">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon" title="** Poderá não ser informado para os CTe de redespacho intermediário e serviço vinculado a multimodal.">
                      Remetente**
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={255}
                      value={nomeRemetente}
                      onChange={e => setNomeRemetente(e.target.value)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-search"
                      className="p-button-warning"
                      onClick={() => setShowConsultaRemetente(true)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-trash"
                      className="p-button-secondary"
                      onClick={() => limparDadosRemetente()}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Inscr. Estadual
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ieRemetente}
                      onChange={e => setIeRemetente(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-7">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon" title="** Poderá não ser informado para os CTe de redespacho intermediário e serviço vinculado a multimodal.">
                      Destinatário**
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={255}
                      value={nomeDestinatario}
                      onChange={e => setNomeDestinatario(e.target.value)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-search"
                      className="p-button-warning"
                      onClick={() => setShowConsultaDestinatario(true)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-trash"
                      className="p-button-secondary"
                      onClick={() => limparDadosDestinatario()}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Inscr. Estadual
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ieDestinatario}
                      onChange={e => setIeDestinatario(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-7">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Recebedor
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={255}
                      value={nomeRecebedor}
                      onChange={e => setNomeRecebedor(e.target.value)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-search"
                      className="p-button-warning"
                      onClick={() => setShowConsultaRecebedor(true)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-trash"
                      className="p-button-secondary"
                      onClick={() => limparDadosRecebedor()}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Inscr. Estadual
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ieRecebedor}
                      onChange={e => setIeRecebedor(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="p-inputgroup">
                    <Input100px className="p-inputgroup-addon">
                      UF
                    </Input100px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ufRecebedor}
                      onChange={e => setUfRecebedor(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-7">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Expedidor
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={255}
                      value={nomeExpedidor}
                      onChange={e => setNomeExpedidor(e.target.value)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-search"
                      className="p-button-warning"
                      onClick={() => setShowConsultaExpedidor(true)}
                    />
                    <Button
                      disabled={disableToCteOS}
                      icon="pi pi-trash"
                      className="p-button-secondary"
                      onClick={() => limparDadosExpedidor()}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Inscr. Estadual
                    </Input155px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ieExpedidor}
                      onChange={e => setIeExpedidor(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="p-inputgroup">
                    <Input100px className="p-inputgroup-addon">
                      UF
                    </Input100px>
                    <InputText
                      disabled
                      maxLength={20}
                      value={ufExpedidor}
                      onChange={e => setUfExpedidor(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Docs. Referenciados" disabled={disableToCteOS}>
              <div className="estamparia-pedido-item">
                <DataTable
                  header="Documentos Referênciados - Inclusão"
                  value={listaNfRef}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedNfRef}
                  onSelectionChange={e => setSelectedNfRef(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupNFRef)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Doc. Referenciado"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoNfRef(0);
                      limparDadosNfReferenciada();
                      setShowCadastroNfRef(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Doc. Referenciado"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditNfRef(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Doc. Referenciado"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteNfRef(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Informações de Carga">
              <div className="row form-elo">
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Produto Predominante*
                    </Input200px>
                    <InputText
                      maxLength={60}
                      value={infCargaProPred}
                      onChange={e => setInfCargaProPred(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Outras Caracteristicas da Carga
                    </Input200px>
                    <InputText
                      maxLength={30}
                      value={infCargaOutrasCaracCarga}
                      onChange={e => setInfCargaOutrasCaracCarga(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor Total Carga
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={infCargaValorTotalCarga}
                      onValueChange={e => setInfCargaValorTotalCarga(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Outras Caracteristicas do Serviço
                    </Input200px>
                    <InputText
                      maxLength={30}
                      value={infCargaOutrasCaracServico}
                      onChange={e => setInfCargaOutrasCaracServico(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor Total Serviço
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      value={infCargaValorTotalServico}
                      onValueChange={e => setInfCargaValorTotalServico(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Quantidades de Carga" disabled={disableToCteOS}>
              <div className="estamparia-pedido-item">
                <DataTable
                  header="Quantidade de Carga - Inclusão"
                  value={listaQuantidadeCarga}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedQuantidadeCarga}
                  onSelectionChange={e => setSelectedQuantidadeCarga(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupQuantidadeCarga)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Doc. Referenciado"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoQuantidadeCarga(0);
                      limparDadosQuantidadeCarga();
                      setShowCadastroQuantidadeCarga(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Quantidade carga"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditQuantidadeCarga(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Quantidade carga"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteQuantidadeCarga(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Serviços (Valores)">
              <div className="row form-elo" hidden={!disableToCteOS}>
                <div className="col-8">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Informações Serviços Prestados
                    </Input200px>
                    <InputText
                      value={infServicoXDescServ}
                      onChange={e => setInfServicoXDescServ(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Quantidade*
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      minFractionDigits={4}
                      maxFractionDigits={4}
                      value={infServicoQuantidadeCarga}
                      onValueChange={e => setInfServicoQuantidadeCarga(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      CST - ICMS / ST*
                    </Input155px>
                    <Dropdown
                      options={listaServicoCST}
                      value={servicoCST}
                      emptyMessage="Nenhum registro a ser exibido"
                      onChange={(e) => setServicoCST(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor Isento
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoValorIsento}
                      onValueChange={e => setServicoValorIsento(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor Outras
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoValorOutro}
                      onValueChange={e => setServicoValorOutro(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon" title="Preencher somente quando o transportador substituído, for optante pelo crédito outorgado previsto no Convênio 106/96 e corresponde ao percentual de 20% do valor do ICMS ST retido. ">
                      Valor do Crédito Outorgado/Presumido
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoValorCredito}
                      onValueChange={e => setServicoValorCredito(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon" title="Obrigatório para CST 00, 20 e 90.">
                      Base Cálculo de ICMS
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoBCICMS}
                      onValueChange={e => setServicoBCICMS(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon" title="Obrigatório para CST 20.">
                      Redução BC ICMS %
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoRedBCICMS}
                      onValueChange={e => setServicoRedBCICMS(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon" title="Obrigatório para CST 00, 20, 60 e 90.">
                      Alíquota ICMS %
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoAliquotaICMS}
                      onValueChange={e => setServicoAliquotaICMS(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon" title="Obrigatório para CST 00, 20, 60 e 90.">
                      Valor do ICMS
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={servicoValorICMS}
                      onValueChange={e => setServicoValorICMS(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="estamparia-pedido-item">
                <DataTable
                  header="Serviços - Inclusão"
                  value={listaServicosValores}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedServicoValor}
                  onSelectionChange={e => setSelectedServicoValor(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupServicoValor)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Valor de Serviço"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoServicoValor(0);
                      limparDadosServicoValor();
                      setShowCadastroServicoValor(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Serviço Valor"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditServicoValor(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Serviço Valor"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteServicoValor(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="IBS / CBS" disabled={false}>
              <div className="row form-elo">
                <div className="col-5">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Codigo Class. Tributária
                    </Input200px>
                    <AutoComplete
                      value={cClassTrib}
                      maxLength={6}
                      suggestions={filteredCClassTrib}
                      completeMethod={searchCClassTrib}
                      field="label"
                      dropdown
                      forceSelection
                      onChange={(e) => setCClassTrib(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-5">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      CST de IBS / CBS
                    </Input200px>
                    <AutoComplete
                      value={ibscbsCst}
                      maxLength={6}
                      suggestions={filteredIbscbsCst}
                      completeMethod={searchIbscbsCst}
                      field="label"
                      dropdown
                      forceSelection
                      onChange={(e) => setIbscbsCst(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Doação
                    </Input155px>
                    <ToggleButton
                      onLabel="Sim"
                      offLabel="Não"
                      onIcon="pi pi-check"
                      offIcon="pi pi-times"
                      checked={indDoacao}
                      onChange={(e) => setIndDoacao(e.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="ICMS Partilha">
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon" title="Obrigatório para CST 00, 20 e 90.">
                      Valor ICMS UF Início
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaVIcmsUfIni}
                      onValueChange={e => setPartilhaVIcmsUfIni(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Valor BC UF Fim
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaVBcUfFim}
                      onValueChange={e => setPartilhaVBcUfFim(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      % ICMS UF Fim
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaPIcmsUfFim}
                      onValueChange={e => setPartilhaPIcmsUfFim(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Valor ICMS UF Fim
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaVIcmsUfFim}
                      onValueChange={e => setPartilhaVIcmsUfFim(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      % FCP UF Fim
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaPFcpUfFim}
                      onValueChange={e => setPartilhaPFcpUfFim(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      Valor FCP UF Fim
                    </Input155px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaVFcpUfFim}
                      onValueChange={e => setPartilhaVFcpUfFim(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      % ICMS Interestadual das UFS Envolvidas
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      minFractionDigits={2}
                      maxFractionDigits={4}
                      value={partilhaPIcmsInter}
                      onValueChange={e => setPartilhaPIcmsInter(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Cobrança">
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Forma de Pagamento*
                    </Input200px>
                    <Dropdown
                      options={listaServicoFormaPagamento}
                      value={fatFormaPag}
                      emptyMessage="Nenhum registro a ser exibido"
                      onChange={(e) => setFatFormaPag(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Número Fatura
                    </Input200px>
                    <InputText
                      maxLength={60}
                      value={fatNFat}
                      onChange={e => setFatNFat(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor Original
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      value={fatVOrig}
                      onValueChange={e => setFatVOrig(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor Desconto
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      value={fatVDesc}
                      onValueChange={e => setFatVDesc(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Valor líquido
                    </Input200px>
                    <InputNumber
                      onFocus={(e) => e.target.select()}
                      mode="currency"
                      inputId="currency-br"
                      currency="BRL"
                      locale="pt-BR"
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      value={fatVLiq}
                      onValueChange={e => setFatVLiq(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="estamparia-pedido-item">
                <DataTable
                  header="Duplicatas - Inclusão"
                  value={listaDuplicata}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedDuplicata}
                  onSelectionChange={e => setSelectedDuplicata(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupDuplicata)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Duplicata"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoDuplicata(0);
                      limparDadosDuplicata();
                      setShowCadastroDuplicata(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Duplicata"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditDuplicata(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Duplicata"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteDuplicata(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Rodoviário" disabled={disableToCteOS}>
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input155px className="p-inputgroup-addon">
                      RNTRC*
                    </Input155px>
                    <InputText
                      onFocus={(e) => e.target.select()}
                      maxLength={8}
                      value={rntrc}
                      onChange={e => setRntrc(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="estamparia-pedido-item">
                <DataTable
                  header="Modal Rodoviário - Inclusão"
                  value={listaRodoviario}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedRodoviario}
                  onSelectionChange={e => setSelectedRodoviario(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupRodoviario)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão Rodoviário (máximo 10)"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={() => {
                      setEditandoRodoviario(0);
                      limparDadosRodoviario();
                      setShowCadastroRodoviario(true);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Rodoviário"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditRodoviario(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Rodoviário"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteRodoviario(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Rodoviário - OS" disabled={!disableToCteOS}>
              <div className="row form-elo">
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Termo Autoriz. de Fretamento - TAF
                    </Input200px>
                    <InputText
                      onFocus={(e) => e.target.select()}
                      maxLength={12}
                      value={taf}
                      onChange={e => setTaf(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Número Registro Estadual
                    </Input200px>
                    <InputText
                      onFocus={(e) => e.target.select()}
                      maxLength={25}
                      value={nroRegistroEstadual}
                      onChange={e => setNroRegistroEstadual(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="CT-e Complementar">
              <div className="estamparia-pedido-item">
                <DataTable
                  value={listaCteComplementar}
                  size="small"
                  stripedRows
                  responsiveLayout="scroll"
                  sortField="item"
                  selectionMode="single"
                  selection={selectedCteComplementar}
                  onSelectionChange={e => setSelectedCteComplementar(e.value)}
                  selectableRows
                  dataKey="item"
                  emptyMessage="Nenhum Item cadastrado"
                >
                  {fillColumns(columnsSetupCteComplementar)}
                </DataTable>
              </div>
              <br />
              <div className="row form-elo">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    title="Inclusão CT-e Complementar"
                    className="btn btn-success"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleInclusaoCteComplementar(e)}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                  <button
                    type="button"
                    title="Alterar Serviço Valor"
                    className="btn btn-warning"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleEditCteComplementar(e)}
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    title="Cancelar Serviço Valor"
                    className="btn btn-danger"
                    style={{ borderRadius: '15px' }}
                    onClick={(e) => handleDeleteCteComplementar(e)}
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Outras Informações">
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Código Município Origem
                    </Input200px>
                    <InputText
                      maxLength={7}
                      value={codigoMunicipioInicio}
                      onChange={e => setCodigoMunicipioInicio(e.target.value)}
                      onBlur={e => onBlurCodigoMunicipioInicio(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Cidade Origem
                    </Input200px>
                    <AutoComplete
                      value={cidadeInicio}
                      maxLength={40}
                      suggestions={filteredMunicipioInicio}
                      completeMethod={searchMunicipioInicio}
                      field="label"
                      dropdown
                      onChange={e => handleChangeCidadeInicio(e)}
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="p-inputgroup">
                    <Input100px className="p-inputgroup-addon">
                      UF
                    </Input100px>
                    <InputText
                      disabled
                      value={ufInicio}
                      onChange={e => setUfInicio(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-4">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Código Município Destino
                    </Input200px>
                    <InputText
                      maxLength={7}
                      value={codigoMunicipioFim}
                      onChange={e => setCodigoMunicipioFim(e.target.value)}
                      onBlur={e => onBlurCodigoMunicipioFim(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Cidade Destino
                    </Input200px>
                    <AutoComplete
                      value={cidadeFim}
                      maxLength={40}
                      suggestions={filteredMunicipioFim}
                      completeMethod={searchMunicipioFim}
                      field="label"
                      dropdown
                      onChange={e => handleChangeCidadeFim(e)}
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="p-inputgroup">
                    <Input100px className="p-inputgroup-addon">
                      UF
                    </Input100px>
                    <InputText
                      disabled
                      value={ufFim}
                      onChange={e => setUfFim(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-12">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Informações Adicionais
                    </Input200px>
                    <InputText
                      value={infoAdicionais}
                      onChange={e => setInfoAdicionais(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row form-elo">
                <div className="col-12">
                  <div className="p-inputgroup">
                    <Input200px className="p-inputgroup-addon">
                      Chave CT-e a Substituir
                    </Input200px>
                    <InputText
                      maxLength={44}
                      minLength={44}
                      value={substituicaoCteChaveAcesso}
                      onChange={e => setSubstituicaoCteChaveAcesso(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>

        <div className="row float-end">
          <div className="col-lg-12 ">
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-success"
            >
              <i className="pi pi-check"></i>
              Salvar
            </button>
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-danger"
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
